/**
 * AUTO-GENERATED by tools/curriculum/generate-course-split-v2-static-aliases.ts.
 * Source: packages/shared-repositories/tools/curriculum-course-split-v2/reviewed-lesson-inventory.ts
 * Product decisions: content/curriculum-restructures/course-split-v2/decisions/*.reviewed.json
 * Static alias contract SHA-256: b3ab54a45066c733aa24251a053a10fd60dc9600cfbb97dd7ee78dc3ececc7b8
 *
 * Old lesson keys remain the canonical static-asset identities. New keys are
 * lookup aliases to those identities; this module contains no lesson IDs or
 * lesson bodies. Do not edit this file by hand.
 */

export type CourseSplitV2StaticLessonAlias = Readonly<{
  oldKey: string;
  newKey: string;
  oldCourseSlug: string;
  newCourseSlug: string;
  lessonSlug: string;
}>;

export const COURSE_SPLIT_V2_STATIC_ALIAS_COUNT = 510 as const;
export const COURSE_SPLIT_V2_STATIC_ALIAS_FINGERPRINT =
  "b3ab54a45066c733aa24251a053a10fd60dc9600cfbb97dd7ee78dc3ececc7b8" as const;

export const COURSE_SPLIT_V2_LESSON_ALIASES = Object.freeze([
  {
    oldKey: "linux-basics/text-processing-pipe-redirect",
    newKey: "linux-text-tools/text-processing-pipe-redirect",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-text-tools",
    lessonSlug: "text-processing-pipe-redirect",
  },
  {
    oldKey: "linux-basics/text-processing-grep-basics",
    newKey: "linux-text-tools/text-processing-grep-basics",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-text-tools",
    lessonSlug: "text-processing-grep-basics",
  },
  {
    oldKey: "linux-basics/text-processing-regex-intro",
    newKey: "linux-text-tools/text-processing-regex-intro",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-text-tools",
    lessonSlug: "text-processing-regex-intro",
  },
  {
    oldKey: "linux-basics/text-processing-grep-regex",
    newKey: "linux-text-tools/text-processing-grep-regex",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-text-tools",
    lessonSlug: "text-processing-grep-regex",
  },
  {
    oldKey: "linux-basics/text-processing-sed-basics",
    newKey: "linux-text-tools/text-processing-sed-basics",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-text-tools",
    lessonSlug: "text-processing-sed-basics",
  },
  {
    oldKey: "linux-basics/text-processing-awk-basics",
    newKey: "linux-text-tools/text-processing-awk-basics",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-text-tools",
    lessonSlug: "text-processing-awk-basics",
  },
  {
    oldKey: "linux-basics/text-processing-pipeline-practice",
    newKey: "linux-text-tools/text-processing-pipeline-practice",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-text-tools",
    lessonSlug: "text-processing-pipeline-practice",
  },
  {
    oldKey: "linux-basics/text-processing-text-processing-quiz",
    newKey: "linux-text-tools/text-processing-text-processing-quiz",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-text-tools",
    lessonSlug: "text-processing-text-processing-quiz",
  },
  {
    oldKey: "linux-basics/file-management-find-command",
    newKey: "linux-text-tools/file-management-find-command",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-text-tools",
    lessonSlug: "file-management-find-command",
  },
  {
    oldKey: "linux-basics/file-management-wildcards-glob",
    newKey: "linux-text-tools/file-management-wildcards-glob",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-text-tools",
    lessonSlug: "file-management-wildcards-glob",
  },
  {
    oldKey: "linux-basics/file-management-compression",
    newKey: "linux-text-tools/file-management-compression",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-text-tools",
    lessonSlug: "file-management-compression",
  },
  {
    oldKey: "linux-basics/file-management-file-attributes",
    newKey: "linux-text-tools/file-management-file-attributes",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-text-tools",
    lessonSlug: "file-management-file-attributes",
  },
  {
    oldKey: "linux-basics/file-management-file-management-quiz",
    newKey: "linux-text-tools/file-management-file-management-quiz",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-text-tools",
    lessonSlug: "file-management-file-management-quiz",
  },
  {
    oldKey: "linux-basics/permissions-users-groups",
    newKey: "linux-operations/permissions-users-groups",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-operations",
    lessonSlug: "permissions-users-groups",
  },
  {
    oldKey: "linux-basics/permissions-permission-reading",
    newKey: "linux-operations/permissions-permission-reading",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-operations",
    lessonSlug: "permissions-permission-reading",
  },
  {
    oldKey: "linux-basics/permissions-chmod-command",
    newKey: "linux-operations/permissions-chmod-command",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-operations",
    lessonSlug: "permissions-chmod-command",
  },
  {
    oldKey: "linux-basics/permissions-chown-command",
    newKey: "linux-operations/permissions-chown-command",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-operations",
    lessonSlug: "permissions-chown-command",
  },
  {
    oldKey: "linux-basics/permissions-sudo-root",
    newKey: "linux-operations/permissions-sudo-root",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-operations",
    lessonSlug: "permissions-sudo-root",
  },
  {
    oldKey: "linux-basics/permissions-executable-scripts",
    newKey: "linux-operations/permissions-executable-scripts",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-operations",
    lessonSlug: "permissions-executable-scripts",
  },
  {
    oldKey: "linux-basics/permissions-permissions-quiz",
    newKey: "linux-operations/permissions-permissions-quiz",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-operations",
    lessonSlug: "permissions-permissions-quiz",
  },
  {
    oldKey: "linux-basics/process-management-what-is-process",
    newKey: "linux-operations/process-management-what-is-process",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-operations",
    lessonSlug: "process-management-what-is-process",
  },
  {
    oldKey: "linux-basics/process-management-ps-command",
    newKey: "linux-operations/process-management-ps-command",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-operations",
    lessonSlug: "process-management-ps-command",
  },
  {
    oldKey: "linux-basics/process-management-top-command",
    newKey: "linux-operations/process-management-top-command",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-operations",
    lessonSlug: "process-management-top-command",
  },
  {
    oldKey: "linux-basics/process-management-kill-command",
    newKey: "linux-operations/process-management-kill-command",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-operations",
    lessonSlug: "process-management-kill-command",
  },
  {
    oldKey: "linux-basics/process-management-foreground-background",
    newKey: "linux-operations/process-management-foreground-background",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-operations",
    lessonSlug: "process-management-foreground-background",
  },
  {
    oldKey: "linux-basics/process-management-nohup-screen-tmux",
    newKey: "linux-operations/process-management-nohup-screen-tmux",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-operations",
    lessonSlug: "process-management-nohup-screen-tmux",
  },
  {
    oldKey: "linux-basics/process-management-process-quiz",
    newKey: "linux-operations/process-management-process-quiz",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-operations",
    lessonSlug: "process-management-process-quiz",
  },
  {
    oldKey: "linux-basics/network-network-basics",
    newKey: "linux-networking/network-network-basics",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-networking",
    lessonSlug: "network-network-basics",
  },
  {
    oldKey: "linux-basics/network-ping-command",
    newKey: "linux-networking/network-ping-command",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-networking",
    lessonSlug: "network-ping-command",
  },
  {
    oldKey: "linux-basics/network-curl-command",
    newKey: "linux-networking/network-curl-command",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-networking",
    lessonSlug: "network-curl-command",
  },
  {
    oldKey: "linux-basics/network-network-info",
    newKey: "linux-networking/network-network-info",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-networking",
    lessonSlug: "network-network-info",
  },
  {
    oldKey: "linux-basics/network-ssh-connection",
    newKey: "linux-networking/network-ssh-connection",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-networking",
    lessonSlug: "network-ssh-connection",
  },
  {
    oldKey: "linux-basics/network-scp-command",
    newKey: "linux-networking/network-scp-command",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-networking",
    lessonSlug: "network-scp-command",
  },
  {
    oldKey: "linux-basics/network-rsync-command",
    newKey: "linux-networking/network-rsync-command",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-networking",
    lessonSlug: "network-rsync-command",
  },
  {
    oldKey: "linux-basics/network-network-quiz",
    newKey: "linux-networking/network-network-quiz",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-networking",
    lessonSlug: "network-network-quiz",
  },
  {
    oldKey: "linux-basics/environment-what-is-env-var",
    newKey: "linux-networking/environment-what-is-env-var",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-networking",
    lessonSlug: "environment-what-is-env-var",
  },
  {
    oldKey: "linux-basics/environment-env-var-commands",
    newKey: "linux-networking/environment-env-var-commands",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-networking",
    lessonSlug: "environment-env-var-commands",
  },
  {
    oldKey: "linux-basics/environment-shell-config-files",
    newKey: "linux-networking/environment-shell-config-files",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-networking",
    lessonSlug: "environment-shell-config-files",
  },
  {
    oldKey: "linux-basics/environment-aliases",
    newKey: "linux-networking/environment-aliases",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-networking",
    lessonSlug: "environment-aliases",
  },
  {
    oldKey: "linux-basics/environment-path-variable",
    newKey: "linux-networking/environment-path-variable",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-networking",
    lessonSlug: "environment-path-variable",
  },
  {
    oldKey: "linux-basics/environment-environment-quiz",
    newKey: "linux-networking/environment-environment-quiz",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-networking",
    lessonSlug: "environment-environment-quiz",
  },
  {
    oldKey: "linux-basics/shell-script-what-is-shell-script",
    newKey: "linux-shell-practical/shell-script-what-is-shell-script",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-shell-practical",
    lessonSlug: "shell-script-what-is-shell-script",
  },
  {
    oldKey: "linux-basics/shell-script-variables-arguments",
    newKey: "linux-shell-practical/shell-script-variables-arguments",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-shell-practical",
    lessonSlug: "shell-script-variables-arguments",
  },
  {
    oldKey: "linux-basics/shell-script-if-statement",
    newKey: "linux-shell-practical/shell-script-if-statement",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-shell-practical",
    lessonSlug: "shell-script-if-statement",
  },
  {
    oldKey: "linux-basics/shell-script-loops",
    newKey: "linux-shell-practical/shell-script-loops",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-shell-practical",
    lessonSlug: "shell-script-loops",
  },
  {
    oldKey: "linux-basics/shell-script-functions",
    newKey: "linux-shell-practical/shell-script-functions",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-shell-practical",
    lessonSlug: "shell-script-functions",
  },
  {
    oldKey: "linux-basics/shell-script-practical-script",
    newKey: "linux-shell-practical/shell-script-practical-script",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-shell-practical",
    lessonSlug: "shell-script-practical-script",
  },
  {
    oldKey: "linux-basics/shell-script-shell-script-quiz",
    newKey: "linux-shell-practical/shell-script-shell-script-quiz",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-shell-practical",
    lessonSlug: "shell-script-shell-script-quiz",
  },
  {
    oldKey: "linux-basics/practical-linux-log-analysis",
    newKey: "linux-shell-practical/practical-linux-log-analysis",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-shell-practical",
    lessonSlug: "practical-linux-log-analysis",
  },
  {
    oldKey: "linux-basics/practical-linux-system-info",
    newKey: "linux-shell-practical/practical-linux-system-info",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-shell-practical",
    lessonSlug: "practical-linux-system-info",
  },
  {
    oldKey: "linux-basics/practical-linux-package-management",
    newKey: "linux-shell-practical/practical-linux-package-management",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-shell-practical",
    lessonSlug: "practical-linux-package-management",
  },
  {
    oldKey: "linux-basics/practical-linux-cron-scheduling",
    newKey: "linux-shell-practical/practical-linux-cron-scheduling",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-shell-practical",
    lessonSlug: "practical-linux-cron-scheduling",
  },
  {
    oldKey: "linux-basics/practical-linux-dev-environment",
    newKey: "linux-shell-practical/practical-linux-dev-environment",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-shell-practical",
    lessonSlug: "practical-linux-dev-environment",
  },
  {
    oldKey: "linux-basics/practical-linux-final-quiz",
    newKey: "linux-shell-practical/practical-linux-final-quiz",
    oldCourseSlug: "linux-basics",
    newCourseSlug: "linux-shell-practical",
    lessonSlug: "practical-linux-final-quiz",
  },
  {
    oldKey: "java-basics/java-if-basic",
    newKey: "java-control-flow/java-if-basic",
    oldCourseSlug: "java-basics",
    newCourseSlug: "java-control-flow",
    lessonSlug: "java-if-basic",
  },
  {
    oldKey: "java-basics/java-if-else",
    newKey: "java-control-flow/java-if-else",
    oldCourseSlug: "java-basics",
    newCourseSlug: "java-control-flow",
    lessonSlug: "java-if-else",
  },
  {
    oldKey: "java-basics/java-if-elseif",
    newKey: "java-control-flow/java-if-elseif",
    oldCourseSlug: "java-basics",
    newCourseSlug: "java-control-flow",
    lessonSlug: "java-if-elseif",
  },
  {
    oldKey: "java-basics/java-condition-grade",
    newKey: "java-control-flow/java-condition-grade",
    oldCourseSlug: "java-basics",
    newCourseSlug: "java-control-flow",
    lessonSlug: "java-condition-grade",
  },
  {
    oldKey: "java-basics/java-condition-leap-year",
    newKey: "java-control-flow/java-condition-leap-year",
    oldCourseSlug: "java-basics",
    newCourseSlug: "java-control-flow",
    lessonSlug: "java-condition-leap-year",
  },
  {
    oldKey: "java-basics/java-switch",
    newKey: "java-control-flow/java-switch",
    oldCourseSlug: "java-basics",
    newCourseSlug: "java-control-flow",
    lessonSlug: "java-switch",
  },
  {
    oldKey: "java-basics/java-ternary",
    newKey: "java-control-flow/java-ternary",
    oldCourseSlug: "java-basics",
    newCourseSlug: "java-control-flow",
    lessonSlug: "java-ternary",
  },
  {
    oldKey: "java-basics/java-condition-janken",
    newKey: "java-control-flow/java-condition-janken",
    oldCourseSlug: "java-basics",
    newCourseSlug: "java-control-flow",
    lessonSlug: "java-condition-janken",
  },
  {
    oldKey: "java-basics/java-condition-fizzbuzz-partial",
    newKey: "java-control-flow/java-condition-fizzbuzz-partial",
    oldCourseSlug: "java-basics",
    newCourseSlug: "java-control-flow",
    lessonSlug: "java-condition-fizzbuzz-partial",
  },
  {
    oldKey: "java-basics/java-chapter3-quiz",
    newKey: "java-control-flow/java-chapter3-quiz",
    oldCourseSlug: "java-basics",
    newCourseSlug: "java-control-flow",
    lessonSlug: "java-chapter3-quiz",
  },
  {
    oldKey: "java-basics/java-for-basic",
    newKey: "java-loops-methods/java-for-basic",
    oldCourseSlug: "java-basics",
    newCourseSlug: "java-loops-methods",
    lessonSlug: "java-for-basic",
  },
  {
    oldKey: "java-basics/java-for-sum",
    newKey: "java-loops-methods/java-for-sum",
    oldCourseSlug: "java-basics",
    newCourseSlug: "java-loops-methods",
    lessonSlug: "java-for-sum",
  },
  {
    oldKey: "java-basics/java-for-multiplication",
    newKey: "java-loops-methods/java-for-multiplication",
    oldCourseSlug: "java-basics",
    newCourseSlug: "java-loops-methods",
    lessonSlug: "java-for-multiplication",
  },
  {
    oldKey: "java-basics/java-while-basic",
    newKey: "java-loops-methods/java-while-basic",
    oldCourseSlug: "java-basics",
    newCourseSlug: "java-loops-methods",
    lessonSlug: "java-while-basic",
  },
  {
    oldKey: "java-basics/java-while-count",
    newKey: "java-loops-methods/java-while-count",
    oldCourseSlug: "java-basics",
    newCourseSlug: "java-loops-methods",
    lessonSlug: "java-while-count",
  },
  {
    oldKey: "java-basics/java-do-while",
    newKey: "java-loops-methods/java-do-while",
    oldCourseSlug: "java-basics",
    newCourseSlug: "java-loops-methods",
    lessonSlug: "java-do-while",
  },
  {
    oldKey: "java-basics/java-nested-loop",
    newKey: "java-loops-methods/java-nested-loop",
    oldCourseSlug: "java-basics",
    newCourseSlug: "java-loops-methods",
    lessonSlug: "java-nested-loop",
  },
  {
    oldKey: "java-basics/java-break-continue",
    newKey: "java-loops-methods/java-break-continue",
    oldCourseSlug: "java-basics",
    newCourseSlug: "java-loops-methods",
    lessonSlug: "java-break-continue",
  },
  {
    oldKey: "java-basics/java-loop-fizzbuzz",
    newKey: "java-loops-methods/java-loop-fizzbuzz",
    oldCourseSlug: "java-basics",
    newCourseSlug: "java-loops-methods",
    lessonSlug: "java-loop-fizzbuzz",
  },
  {
    oldKey: "java-basics/java-loop-quiz",
    newKey: "java-loops-methods/java-loop-quiz",
    oldCourseSlug: "java-basics",
    newCourseSlug: "java-loops-methods",
    lessonSlug: "java-loop-quiz",
  },
  {
    oldKey: "java-basics/java-chapter4-quiz",
    newKey: "java-loops-methods/java-chapter4-quiz",
    oldCourseSlug: "java-basics",
    newCourseSlug: "java-loops-methods",
    lessonSlug: "java-chapter4-quiz",
  },
  {
    oldKey: "java-basics/java-method-basic",
    newKey: "java-loops-methods/java-method-basic",
    oldCourseSlug: "java-basics",
    newCourseSlug: "java-loops-methods",
    lessonSlug: "java-method-basic",
  },
  {
    oldKey: "java-basics/java-method-args",
    newKey: "java-loops-methods/java-method-args",
    oldCourseSlug: "java-basics",
    newCourseSlug: "java-loops-methods",
    lessonSlug: "java-method-args",
  },
  {
    oldKey: "java-basics/java-method-return",
    newKey: "java-loops-methods/java-method-return",
    oldCourseSlug: "java-basics",
    newCourseSlug: "java-loops-methods",
    lessonSlug: "java-method-return",
  },
  {
    oldKey: "java-basics/java-method-multi-args",
    newKey: "java-loops-methods/java-method-multi-args",
    oldCourseSlug: "java-basics",
    newCourseSlug: "java-loops-methods",
    lessonSlug: "java-method-multi-args",
  },
  {
    oldKey: "java-basics/java-method-overload",
    newKey: "java-loops-methods/java-method-overload",
    oldCourseSlug: "java-basics",
    newCourseSlug: "java-loops-methods",
    lessonSlug: "java-method-overload",
  },
  {
    oldKey: "java-basics/java-method-quiz",
    newKey: "java-loops-methods/java-method-quiz",
    oldCourseSlug: "java-basics",
    newCourseSlug: "java-loops-methods",
    lessonSlug: "java-method-quiz",
  },
  {
    oldKey: "java-basics/java-method-practice",
    newKey: "java-loops-methods/java-method-practice",
    oldCourseSlug: "java-basics",
    newCourseSlug: "java-loops-methods",
    lessonSlug: "java-method-practice",
  },
  {
    oldKey: "java-basics/java-chapter5-quiz",
    newKey: "java-loops-methods/java-chapter5-quiz",
    oldCourseSlug: "java-basics",
    newCourseSlug: "java-loops-methods",
    lessonSlug: "java-chapter5-quiz",
  },
  {
    oldKey: "java-basics/java-array-basic",
    newKey: "java-arrays-collections/java-array-basic",
    oldCourseSlug: "java-basics",
    newCourseSlug: "java-arrays-collections",
    lessonSlug: "java-array-basic",
  },
  {
    oldKey: "java-basics/java-array-access",
    newKey: "java-arrays-collections/java-array-access",
    oldCourseSlug: "java-basics",
    newCourseSlug: "java-arrays-collections",
    lessonSlug: "java-array-access",
  },
  {
    oldKey: "java-basics/java-array-loop",
    newKey: "java-arrays-collections/java-array-loop",
    oldCourseSlug: "java-basics",
    newCourseSlug: "java-arrays-collections",
    lessonSlug: "java-array-loop",
  },
  {
    oldKey: "java-basics/java-array-sum",
    newKey: "java-arrays-collections/java-array-sum",
    oldCourseSlug: "java-basics",
    newCourseSlug: "java-arrays-collections",
    lessonSlug: "java-array-sum",
  },
  {
    oldKey: "java-basics/java-array-avg",
    newKey: "java-arrays-collections/java-array-avg",
    oldCourseSlug: "java-basics",
    newCourseSlug: "java-arrays-collections",
    lessonSlug: "java-array-avg",
  },
  {
    oldKey: "java-basics/java-array-max",
    newKey: "java-arrays-collections/java-array-max",
    oldCourseSlug: "java-basics",
    newCourseSlug: "java-arrays-collections",
    lessonSlug: "java-array-max",
  },
  {
    oldKey: "java-basics/java-array-search",
    newKey: "java-arrays-collections/java-array-search",
    oldCourseSlug: "java-basics",
    newCourseSlug: "java-arrays-collections",
    lessonSlug: "java-array-search",
  },
  {
    oldKey: "java-basics/java-array-foreach",
    newKey: "java-arrays-collections/java-array-foreach",
    oldCourseSlug: "java-basics",
    newCourseSlug: "java-arrays-collections",
    lessonSlug: "java-array-foreach",
  },
  {
    oldKey: "java-basics/java-array-quiz",
    newKey: "java-arrays-collections/java-array-quiz",
    oldCourseSlug: "java-basics",
    newCourseSlug: "java-arrays-collections",
    lessonSlug: "java-array-quiz",
  },
  {
    oldKey: "java-basics/java-chapter6-quiz",
    newKey: "java-arrays-collections/java-chapter6-quiz",
    oldCourseSlug: "java-basics",
    newCourseSlug: "java-arrays-collections",
    lessonSlug: "java-chapter6-quiz",
  },
  {
    oldKey: "java-basics/java-class-define",
    newKey: "java-oop/java-class-define",
    oldCourseSlug: "java-basics",
    newCourseSlug: "java-oop",
    lessonSlug: "java-class-define",
  },
  {
    oldKey: "java-basics/java-class-fields",
    newKey: "java-oop/java-class-fields",
    oldCourseSlug: "java-basics",
    newCourseSlug: "java-oop",
    lessonSlug: "java-class-fields",
  },
  {
    oldKey: "java-basics/java-class-methods",
    newKey: "java-oop/java-class-methods",
    oldCourseSlug: "java-basics",
    newCourseSlug: "java-oop",
    lessonSlug: "java-class-methods",
  },
  {
    oldKey: "java-basics/java-class-instance",
    newKey: "java-oop/java-class-instance",
    oldCourseSlug: "java-basics",
    newCourseSlug: "java-oop",
    lessonSlug: "java-class-instance",
  },
  {
    oldKey: "java-basics/java-class-constructor",
    newKey: "java-oop/java-class-constructor",
    oldCourseSlug: "java-basics",
    newCourseSlug: "java-oop",
    lessonSlug: "java-class-constructor",
  },
  {
    oldKey: "java-basics/java-class-this",
    newKey: "java-oop/java-class-this",
    oldCourseSlug: "java-basics",
    newCourseSlug: "java-oop",
    lessonSlug: "java-class-this",
  },
  {
    oldKey: "java-basics/java-class-encapsulation",
    newKey: "java-oop/java-class-encapsulation",
    oldCourseSlug: "java-basics",
    newCourseSlug: "java-oop",
    lessonSlug: "java-class-encapsulation",
  },
  {
    oldKey: "java-basics/java-class-person",
    newKey: "java-oop/java-class-person",
    oldCourseSlug: "java-basics",
    newCourseSlug: "java-oop",
    lessonSlug: "java-class-person",
  },
  {
    oldKey: "java-basics/java-class-product",
    newKey: "java-oop/java-class-product",
    oldCourseSlug: "java-basics",
    newCourseSlug: "java-oop",
    lessonSlug: "java-class-product",
  },
  {
    oldKey: "java-basics/java-class-bank",
    newKey: "java-oop/java-class-bank",
    oldCourseSlug: "java-basics",
    newCourseSlug: "java-oop",
    lessonSlug: "java-class-bank",
  },
  {
    oldKey: "java-basics/java-class-toString",
    newKey: "java-oop/java-class-toString",
    oldCourseSlug: "java-basics",
    newCourseSlug: "java-oop",
    lessonSlug: "java-class-toString",
  },
  {
    oldKey: "java-basics/java-class-quiz",
    newKey: "java-oop/java-class-quiz",
    oldCourseSlug: "java-basics",
    newCourseSlug: "java-oop",
    lessonSlug: "java-class-quiz",
  },
  {
    oldKey: "java-basics/java-final-quiz",
    newKey: "java-oop/java-final-quiz",
    oldCourseSlug: "java-basics",
    newCourseSlug: "java-oop",
    lessonSlug: "java-final-quiz",
  },
  {
    oldKey: "java-intermediate/java-list-basics",
    newKey: "java-arrays-collections/java-list-basics",
    oldCourseSlug: "java-intermediate",
    newCourseSlug: "java-arrays-collections",
    lessonSlug: "java-list-basics",
  },
  {
    oldKey: "java-intermediate/java-list-iterate",
    newKey: "java-arrays-collections/java-list-iterate",
    oldCourseSlug: "java-intermediate",
    newCourseSlug: "java-arrays-collections",
    lessonSlug: "java-list-iterate",
  },
  {
    oldKey: "java-intermediate/java-list-remove",
    newKey: "java-arrays-collections/java-list-remove",
    oldCourseSlug: "java-intermediate",
    newCourseSlug: "java-arrays-collections",
    lessonSlug: "java-list-remove",
  },
  {
    oldKey: "java-intermediate/java-map-basics",
    newKey: "java-arrays-collections/java-map-basics",
    oldCourseSlug: "java-intermediate",
    newCourseSlug: "java-arrays-collections",
    lessonSlug: "java-map-basics",
  },
  {
    oldKey: "java-intermediate/java-map-iterate",
    newKey: "java-arrays-collections/java-map-iterate",
    oldCourseSlug: "java-intermediate",
    newCourseSlug: "java-arrays-collections",
    lessonSlug: "java-map-iterate",
  },
  {
    oldKey: "java-intermediate/java-set-basics",
    newKey: "java-arrays-collections/java-set-basics",
    oldCourseSlug: "java-intermediate",
    newCourseSlug: "java-arrays-collections",
    lessonSlug: "java-set-basics",
  },
  {
    oldKey: "java-intermediate/java-collections-utility",
    newKey: "java-arrays-collections/java-collections-utility",
    oldCourseSlug: "java-intermediate",
    newCourseSlug: "java-arrays-collections",
    lessonSlug: "java-collections-utility",
  },
  {
    oldKey: "java-intermediate/java-collection-chapter1-quiz",
    newKey: "java-arrays-collections/java-collection-chapter1-quiz",
    oldCourseSlug: "java-intermediate",
    newCourseSlug: "java-arrays-collections",
    lessonSlug: "java-collection-chapter1-quiz",
  },
  {
    oldKey: "java-intermediate/java-try-catch",
    newKey: "java-exceptions-io/java-try-catch",
    oldCourseSlug: "java-intermediate",
    newCourseSlug: "java-exceptions-io",
    lessonSlug: "java-try-catch",
  },
  {
    oldKey: "java-intermediate/java-multiple-catch",
    newKey: "java-exceptions-io/java-multiple-catch",
    oldCourseSlug: "java-intermediate",
    newCourseSlug: "java-exceptions-io",
    lessonSlug: "java-multiple-catch",
  },
  {
    oldKey: "java-intermediate/java-throws",
    newKey: "java-exceptions-io/java-throws",
    oldCourseSlug: "java-intermediate",
    newCourseSlug: "java-exceptions-io",
    lessonSlug: "java-throws",
  },
  {
    oldKey: "java-intermediate/java-custom-exception",
    newKey: "java-exceptions-io/java-custom-exception",
    oldCourseSlug: "java-intermediate",
    newCourseSlug: "java-exceptions-io",
    lessonSlug: "java-custom-exception",
  },
  {
    oldKey: "java-intermediate/java-try-with-resources",
    newKey: "java-exceptions-io/java-try-with-resources",
    oldCourseSlug: "java-intermediate",
    newCourseSlug: "java-exceptions-io",
    lessonSlug: "java-try-with-resources",
  },
  {
    oldKey: "java-intermediate/java-finally",
    newKey: "java-exceptions-io/java-finally",
    oldCourseSlug: "java-intermediate",
    newCourseSlug: "java-exceptions-io",
    lessonSlug: "java-finally",
  },
  {
    oldKey: "java-intermediate/java-exception-chapter3-quiz",
    newKey: "java-exceptions-io/java-exception-chapter3-quiz",
    oldCourseSlug: "java-intermediate",
    newCourseSlug: "java-exceptions-io",
    lessonSlug: "java-exception-chapter3-quiz",
  },
  {
    oldKey: "java-intermediate/java-stream-create",
    newKey: "java-stream-functional/java-stream-create",
    oldCourseSlug: "java-intermediate",
    newCourseSlug: "java-stream-functional",
    lessonSlug: "java-stream-create",
  },
  {
    oldKey: "java-intermediate/java-stream-filter",
    newKey: "java-stream-functional/java-stream-filter",
    oldCourseSlug: "java-intermediate",
    newCourseSlug: "java-stream-functional",
    lessonSlug: "java-stream-filter",
  },
  {
    oldKey: "java-intermediate/java-stream-map",
    newKey: "java-stream-functional/java-stream-map",
    oldCourseSlug: "java-intermediate",
    newCourseSlug: "java-stream-functional",
    lessonSlug: "java-stream-map",
  },
  {
    oldKey: "java-intermediate/java-stream-reduce",
    newKey: "java-stream-functional/java-stream-reduce",
    oldCourseSlug: "java-intermediate",
    newCourseSlug: "java-stream-functional",
    lessonSlug: "java-stream-reduce",
  },
  {
    oldKey: "java-intermediate/java-stream-collect",
    newKey: "java-stream-functional/java-stream-collect",
    oldCourseSlug: "java-intermediate",
    newCourseSlug: "java-stream-functional",
    lessonSlug: "java-stream-collect",
  },
  {
    oldKey: "java-intermediate/java-stream-sorted",
    newKey: "java-stream-functional/java-stream-sorted",
    oldCourseSlug: "java-intermediate",
    newCourseSlug: "java-stream-functional",
    lessonSlug: "java-stream-sorted",
  },
  {
    oldKey: "java-intermediate/java-stream-distinct",
    newKey: "java-stream-functional/java-stream-distinct",
    oldCourseSlug: "java-intermediate",
    newCourseSlug: "java-stream-functional",
    lessonSlug: "java-stream-distinct",
  },
  {
    oldKey: "java-intermediate/java-stream-limit-skip",
    newKey: "java-stream-functional/java-stream-limit-skip",
    oldCourseSlug: "java-intermediate",
    newCourseSlug: "java-stream-functional",
    lessonSlug: "java-stream-limit-skip",
  },
  {
    oldKey: "java-intermediate/java-stream-parallel",
    newKey: "java-stream-functional/java-stream-parallel",
    oldCourseSlug: "java-intermediate",
    newCourseSlug: "java-stream-functional",
    lessonSlug: "java-stream-parallel",
  },
  {
    oldKey: "java-intermediate/java-stream-chapter4-quiz",
    newKey: "java-stream-functional/java-stream-chapter4-quiz",
    oldCourseSlug: "java-intermediate",
    newCourseSlug: "java-stream-functional",
    lessonSlug: "java-stream-chapter4-quiz",
  },
  {
    oldKey: "java-intermediate/java-lambda-basics",
    newKey: "java-stream-functional/java-lambda-basics",
    oldCourseSlug: "java-intermediate",
    newCourseSlug: "java-stream-functional",
    lessonSlug: "java-lambda-basics",
  },
  {
    oldKey: "java-intermediate/java-method-reference",
    newKey: "java-stream-functional/java-method-reference",
    oldCourseSlug: "java-intermediate",
    newCourseSlug: "java-stream-functional",
    lessonSlug: "java-method-reference",
  },
  {
    oldKey: "java-intermediate/java-function-interface",
    newKey: "java-stream-functional/java-function-interface",
    oldCourseSlug: "java-intermediate",
    newCourseSlug: "java-stream-functional",
    lessonSlug: "java-function-interface",
  },
  {
    oldKey: "java-intermediate/java-predicate-interface",
    newKey: "java-stream-functional/java-predicate-interface",
    oldCourseSlug: "java-intermediate",
    newCourseSlug: "java-stream-functional",
    lessonSlug: "java-predicate-interface",
  },
  {
    oldKey: "java-intermediate/java-consumer-supplier",
    newKey: "java-stream-functional/java-consumer-supplier",
    oldCourseSlug: "java-intermediate",
    newCourseSlug: "java-stream-functional",
    lessonSlug: "java-consumer-supplier",
  },
  {
    oldKey: "java-intermediate/java-bifunction",
    newKey: "java-stream-functional/java-bifunction",
    oldCourseSlug: "java-intermediate",
    newCourseSlug: "java-stream-functional",
    lessonSlug: "java-bifunction",
  },
  {
    oldKey: "java-intermediate/java-functional-chapter5-quiz",
    newKey: "java-stream-functional/java-functional-chapter5-quiz",
    oldCourseSlug: "java-intermediate",
    newCourseSlug: "java-stream-functional",
    lessonSlug: "java-functional-chapter5-quiz",
  },
  {
    oldKey: "java-intermediate/java-string-format",
    newKey: "java-standard-library/java-string-format",
    oldCourseSlug: "java-intermediate",
    newCourseSlug: "java-standard-library",
    lessonSlug: "java-string-format",
  },
  {
    oldKey: "java-intermediate/java-stringbuilder",
    newKey: "java-standard-library/java-stringbuilder",
    oldCourseSlug: "java-intermediate",
    newCourseSlug: "java-standard-library",
    lessonSlug: "java-stringbuilder",
  },
  {
    oldKey: "java-intermediate/java-regex",
    newKey: "java-standard-library/java-regex",
    oldCourseSlug: "java-intermediate",
    newCourseSlug: "java-standard-library",
    lessonSlug: "java-regex",
  },
  {
    oldKey: "java-intermediate/java-string-split-join",
    newKey: "java-standard-library/java-string-split-join",
    oldCourseSlug: "java-intermediate",
    newCourseSlug: "java-standard-library",
    lessonSlug: "java-string-split-join",
  },
  {
    oldKey: "java-intermediate/java-string-chapter6-quiz",
    newKey: "java-standard-library/java-string-chapter6-quiz",
    oldCourseSlug: "java-intermediate",
    newCourseSlug: "java-standard-library",
    lessonSlug: "java-string-chapter6-quiz",
  },
  {
    oldKey: "java-intermediate/java-localdate",
    newKey: "java-standard-library/java-localdate",
    oldCourseSlug: "java-intermediate",
    newCourseSlug: "java-standard-library",
    lessonSlug: "java-localdate",
  },
  {
    oldKey: "java-intermediate/java-localdatetime",
    newKey: "java-standard-library/java-localdatetime",
    oldCourseSlug: "java-intermediate",
    newCourseSlug: "java-standard-library",
    lessonSlug: "java-localdatetime",
  },
  {
    oldKey: "java-intermediate/java-duration",
    newKey: "java-standard-library/java-duration",
    oldCourseSlug: "java-intermediate",
    newCourseSlug: "java-standard-library",
    lessonSlug: "java-duration",
  },
  {
    oldKey: "java-intermediate/java-date-format",
    newKey: "java-standard-library/java-date-format",
    oldCourseSlug: "java-intermediate",
    newCourseSlug: "java-standard-library",
    lessonSlug: "java-date-format",
  },
  {
    oldKey: "java-intermediate/java-date-arithmetic",
    newKey: "java-standard-library/java-date-arithmetic",
    oldCourseSlug: "java-intermediate",
    newCourseSlug: "java-standard-library",
    lessonSlug: "java-date-arithmetic",
  },
  {
    oldKey: "java-intermediate/java-date-chapter7-quiz",
    newKey: "java-standard-library/java-date-chapter7-quiz",
    oldCourseSlug: "java-intermediate",
    newCourseSlug: "java-standard-library",
    lessonSlug: "java-date-chapter7-quiz",
  },
  {
    oldKey: "java-intermediate/java-io-files-write",
    newKey: "java-exceptions-io/java-io-files-write",
    oldCourseSlug: "java-intermediate",
    newCourseSlug: "java-exceptions-io",
    lessonSlug: "java-io-files-write",
  },
  {
    oldKey: "java-intermediate/java-io-read-lines",
    newKey: "java-exceptions-io/java-io-read-lines",
    oldCourseSlug: "java-intermediate",
    newCourseSlug: "java-exceptions-io",
    lessonSlug: "java-io-read-lines",
  },
  {
    oldKey: "java-intermediate/java-io-path",
    newKey: "java-exceptions-io/java-io-path",
    oldCourseSlug: "java-intermediate",
    newCourseSlug: "java-exceptions-io",
    lessonSlug: "java-io-path",
  },
  {
    oldKey: "java-intermediate/java-io-buffered",
    newKey: "java-exceptions-io/java-io-buffered",
    oldCourseSlug: "java-intermediate",
    newCourseSlug: "java-exceptions-io",
    lessonSlug: "java-io-buffered",
  },
  {
    oldKey: "java-intermediate/java-io-exists",
    newKey: "java-exceptions-io/java-io-exists",
    oldCourseSlug: "java-intermediate",
    newCourseSlug: "java-exceptions-io",
    lessonSlug: "java-io-exists",
  },
  {
    oldKey: "java-intermediate/java-io-chapter8-quiz",
    newKey: "java-exceptions-io/java-io-chapter8-quiz",
    oldCourseSlug: "java-intermediate",
    newCourseSlug: "java-exceptions-io",
    lessonSlug: "java-io-chapter8-quiz",
  },
  {
    oldKey: "go-basics/go-if-go",
    newKey: "go-control-flow/go-if-go",
    oldCourseSlug: "go-basics",
    newCourseSlug: "go-control-flow",
    lessonSlug: "go-if-go",
  },
  {
    oldKey: "go-basics/go-for-only",
    newKey: "go-control-flow/go-for-only",
    oldCourseSlug: "go-basics",
    newCourseSlug: "go-control-flow",
    lessonSlug: "go-for-only",
  },
  {
    oldKey: "go-basics/go-for-patterns",
    newKey: "go-control-flow/go-for-patterns",
    oldCourseSlug: "go-basics",
    newCourseSlug: "go-control-flow",
    lessonSlug: "go-for-patterns",
  },
  {
    oldKey: "go-basics/go-switch-go",
    newKey: "go-control-flow/go-switch-go",
    oldCourseSlug: "go-basics",
    newCourseSlug: "go-control-flow",
    lessonSlug: "go-switch-go",
  },
  {
    oldKey: "go-basics/go-fizzbuzz-go",
    newKey: "go-control-flow/go-fizzbuzz-go",
    oldCourseSlug: "go-basics",
    newCourseSlug: "go-control-flow",
    lessonSlug: "go-fizzbuzz-go",
  },
  {
    oldKey: "go-basics/go-loop-aggregate",
    newKey: "go-control-flow/go-loop-aggregate",
    oldCourseSlug: "go-basics",
    newCourseSlug: "go-control-flow",
    lessonSlug: "go-loop-aggregate",
  },
  {
    oldKey: "go-basics/go-ch3-build",
    newKey: "go-control-flow/go-ch3-build",
    oldCourseSlug: "go-basics",
    newCourseSlug: "go-control-flow",
    lessonSlug: "go-ch3-build",
  },
  {
    oldKey: "go-basics/go-ch3-quiz",
    newKey: "go-control-flow/go-ch3-quiz",
    oldCourseSlug: "go-basics",
    newCourseSlug: "go-control-flow",
    lessonSlug: "go-ch3-quiz",
  },
  {
    oldKey: "go-basics/go-functions",
    newKey: "go-control-flow/go-functions",
    oldCourseSlug: "go-basics",
    newCourseSlug: "go-control-flow",
    lessonSlug: "go-functions",
  },
  {
    oldKey: "go-basics/go-multiple-returns",
    newKey: "go-control-flow/go-multiple-returns",
    oldCourseSlug: "go-basics",
    newCourseSlug: "go-control-flow",
    lessonSlug: "go-multiple-returns",
  },
  {
    oldKey: "go-basics/go-error-handling",
    newKey: "go-control-flow/go-error-handling",
    oldCourseSlug: "go-basics",
    newCourseSlug: "go-control-flow",
    lessonSlug: "go-error-handling",
  },
  {
    oldKey: "go-basics/go-creating-errors",
    newKey: "go-control-flow/go-creating-errors",
    oldCourseSlug: "go-basics",
    newCourseSlug: "go-control-flow",
    lessonSlug: "go-creating-errors",
  },
  {
    oldKey: "go-basics/go-defer",
    newKey: "go-control-flow/go-defer",
    oldCourseSlug: "go-basics",
    newCourseSlug: "go-control-flow",
    lessonSlug: "go-defer",
  },
  {
    oldKey: "go-basics/go-ch4-build",
    newKey: "go-control-flow/go-ch4-build",
    oldCourseSlug: "go-basics",
    newCourseSlug: "go-control-flow",
    lessonSlug: "go-ch4-build",
  },
  {
    oldKey: "go-basics/go-ch4-quiz",
    newKey: "go-control-flow/go-ch4-quiz",
    oldCourseSlug: "go-basics",
    newCourseSlug: "go-control-flow",
    lessonSlug: "go-ch4-quiz",
  },
  {
    oldKey: "go-basics/go-arrays-go",
    newKey: "go-data-structures/go-arrays-go",
    oldCourseSlug: "go-basics",
    newCourseSlug: "go-data-structures",
    lessonSlug: "go-arrays-go",
  },
  {
    oldKey: "go-basics/go-slices",
    newKey: "go-data-structures/go-slices",
    oldCourseSlug: "go-basics",
    newCourseSlug: "go-data-structures",
    lessonSlug: "go-slices",
  },
  {
    oldKey: "go-basics/go-append-slices",
    newKey: "go-data-structures/go-append-slices",
    oldCourseSlug: "go-basics",
    newCourseSlug: "go-data-structures",
    lessonSlug: "go-append-slices",
  },
  {
    oldKey: "go-basics/go-range",
    newKey: "go-data-structures/go-range",
    oldCourseSlug: "go-basics",
    newCourseSlug: "go-data-structures",
    lessonSlug: "go-range",
  },
  {
    oldKey: "go-basics/go-maps",
    newKey: "go-data-structures/go-maps",
    oldCourseSlug: "go-basics",
    newCourseSlug: "go-data-structures",
    lessonSlug: "go-maps",
  },
  {
    oldKey: "go-basics/go-map-exists",
    newKey: "go-data-structures/go-map-exists",
    oldCourseSlug: "go-basics",
    newCourseSlug: "go-data-structures",
    lessonSlug: "go-map-exists",
  },
  {
    oldKey: "go-basics/go-ch5-build",
    newKey: "go-data-structures/go-ch5-build",
    oldCourseSlug: "go-basics",
    newCourseSlug: "go-data-structures",
    lessonSlug: "go-ch5-build",
  },
  {
    oldKey: "go-basics/go-ch5-quiz",
    newKey: "go-data-structures/go-ch5-quiz",
    oldCourseSlug: "go-basics",
    newCourseSlug: "go-data-structures",
    lessonSlug: "go-ch5-quiz",
  },
  {
    oldKey: "go-basics/go-structs",
    newKey: "go-data-structures/go-structs",
    oldCourseSlug: "go-basics",
    newCourseSlug: "go-data-structures",
    lessonSlug: "go-structs",
  },
  {
    oldKey: "go-basics/go-struct-init",
    newKey: "go-data-structures/go-struct-init",
    oldCourseSlug: "go-basics",
    newCourseSlug: "go-data-structures",
    lessonSlug: "go-struct-init",
  },
  {
    oldKey: "go-basics/go-methods",
    newKey: "go-data-structures/go-methods",
    oldCourseSlug: "go-basics",
    newCourseSlug: "go-data-structures",
    lessonSlug: "go-methods",
  },
  {
    oldKey: "go-basics/go-pointer-receivers",
    newKey: "go-data-structures/go-pointer-receivers",
    oldCourseSlug: "go-basics",
    newCourseSlug: "go-data-structures",
    lessonSlug: "go-pointer-receivers",
  },
  {
    oldKey: "go-basics/go-constructor-func",
    newKey: "go-data-structures/go-constructor-func",
    oldCourseSlug: "go-basics",
    newCourseSlug: "go-data-structures",
    lessonSlug: "go-constructor-func",
  },
  {
    oldKey: "go-basics/go-struct-slices",
    newKey: "go-data-structures/go-struct-slices",
    oldCourseSlug: "go-basics",
    newCourseSlug: "go-data-structures",
    lessonSlug: "go-struct-slices",
  },
  {
    oldKey: "go-basics/go-ch6-build",
    newKey: "go-data-structures/go-ch6-build",
    oldCourseSlug: "go-basics",
    newCourseSlug: "go-data-structures",
    lessonSlug: "go-ch6-build",
  },
  {
    oldKey: "go-basics/go-ch6-quiz",
    newKey: "go-data-structures/go-ch6-quiz",
    oldCourseSlug: "go-basics",
    newCourseSlug: "go-data-structures",
    lessonSlug: "go-ch6-quiz",
  },
  {
    oldKey: "go-basics/go-goroutines",
    newKey: "go-web-api/go-goroutines",
    oldCourseSlug: "go-basics",
    newCourseSlug: "go-web-api",
    lessonSlug: "go-goroutines",
  },
  {
    oldKey: "go-basics/go-channels",
    newKey: "go-web-api/go-channels",
    oldCourseSlug: "go-basics",
    newCourseSlug: "go-web-api",
    lessonSlug: "go-channels",
  },
  {
    oldKey: "go-basics/go-waitgroup",
    newKey: "go-web-api/go-waitgroup",
    oldCourseSlug: "go-basics",
    newCourseSlug: "go-web-api",
    lessonSlug: "go-waitgroup",
  },
  {
    oldKey: "go-basics/go-concurrency-care",
    newKey: "go-web-api/go-concurrency-care",
    oldCourseSlug: "go-basics",
    newCourseSlug: "go-web-api",
    lessonSlug: "go-concurrency-care",
  },
  {
    oldKey: "go-basics/go-ch7-build",
    newKey: "go-web-api/go-ch7-build",
    oldCourseSlug: "go-basics",
    newCourseSlug: "go-web-api",
    lessonSlug: "go-ch7-build",
  },
  {
    oldKey: "go-basics/go-ch7-quiz",
    newKey: "go-web-api/go-ch7-quiz",
    oldCourseSlug: "go-basics",
    newCourseSlug: "go-web-api",
    lessonSlug: "go-ch7-quiz",
  },
  {
    oldKey: "go-basics/go-net-http",
    newKey: "go-web-api/go-net-http",
    oldCourseSlug: "go-basics",
    newCourseSlug: "go-web-api",
    lessonSlug: "go-net-http",
  },
  {
    oldKey: "go-basics/go-handlers",
    newKey: "go-web-api/go-handlers",
    oldCourseSlug: "go-basics",
    newCourseSlug: "go-web-api",
    lessonSlug: "go-handlers",
  },
  {
    oldKey: "go-basics/go-json-encode",
    newKey: "go-web-api/go-json-encode",
    oldCourseSlug: "go-basics",
    newCourseSlug: "go-web-api",
    lessonSlug: "go-json-encode",
  },
  {
    oldKey: "go-basics/go-routing",
    newKey: "go-web-api/go-routing",
    oldCourseSlug: "go-basics",
    newCourseSlug: "go-web-api",
    lessonSlug: "go-routing",
  },
  {
    oldKey: "go-basics/go-get-list",
    newKey: "go-web-api/go-get-list",
    oldCourseSlug: "go-basics",
    newCourseSlug: "go-web-api",
    lessonSlug: "go-get-list",
  },
  {
    oldKey: "go-basics/go-get-detail",
    newKey: "go-web-api/go-get-detail",
    oldCourseSlug: "go-basics",
    newCourseSlug: "go-web-api",
    lessonSlug: "go-get-detail",
  },
  {
    oldKey: "go-basics/go-post-create",
    newKey: "go-web-api/go-post-create",
    oldCourseSlug: "go-basics",
    newCourseSlug: "go-web-api",
    lessonSlug: "go-post-create",
  },
  {
    oldKey: "go-basics/go-ch8-build",
    newKey: "go-web-api/go-ch8-build",
    oldCourseSlug: "go-basics",
    newCourseSlug: "go-web-api",
    lessonSlug: "go-ch8-build",
  },
  {
    oldKey: "go-basics/go-ch8-quiz",
    newKey: "go-web-api/go-ch8-quiz",
    oldCourseSlug: "go-basics",
    newCourseSlug: "go-web-api",
    lessonSlug: "go-ch8-quiz",
  },
  {
    oldKey: "go-basics/go-final-api",
    newKey: "go-web-api/go-final-api",
    oldCourseSlug: "go-basics",
    newCourseSlug: "go-web-api",
    lessonSlug: "go-final-api",
  },
  {
    oldKey: "go-basics/go-final-swap",
    newKey: "go-web-api/go-final-swap",
    oldCourseSlug: "go-basics",
    newCourseSlug: "go-web-api",
    lessonSlug: "go-final-swap",
  },
  {
    oldKey: "go-basics/go-final-deploy",
    newKey: "go-web-api/go-final-deploy",
    oldCourseSlug: "go-basics",
    newCourseSlug: "go-web-api",
    lessonSlug: "go-final-deploy",
  },
  {
    oldKey: "go-basics/go-final-extend",
    newKey: "go-web-api/go-final-extend",
    oldCourseSlug: "go-basics",
    newCourseSlug: "go-web-api",
    lessonSlug: "go-final-extend",
  },
  {
    oldKey: "go-basics/go-final-next",
    newKey: "go-web-api/go-final-next",
    oldCourseSlug: "go-basics",
    newCourseSlug: "go-web-api",
    lessonSlug: "go-final-next",
  },
  {
    oldKey: "nodejs/nd-http-concept",
    newKey: "nodejs-api-development/nd-http-concept",
    oldCourseSlug: "nodejs",
    newCourseSlug: "nodejs-api-development",
    lessonSlug: "nd-http-concept",
  },
  {
    oldKey: "nodejs/nd-express-setup",
    newKey: "nodejs-api-development/nd-express-setup",
    oldCourseSlug: "nodejs",
    newCourseSlug: "nodejs-api-development",
    lessonSlug: "nd-express-setup",
  },
  {
    oldKey: "nodejs/nd-routing",
    newKey: "nodejs-api-development/nd-routing",
    oldCourseSlug: "nodejs",
    newCourseSlug: "nodejs-api-development",
    lessonSlug: "nd-routing",
  },
  {
    oldKey: "nodejs/nd-json-response",
    newKey: "nodejs-api-development/nd-json-response",
    oldCourseSlug: "nodejs",
    newCourseSlug: "nodejs-api-development",
    lessonSlug: "nd-json-response",
  },
  {
    oldKey: "nodejs/nd-dev-loop",
    newKey: "nodejs-api-development/nd-dev-loop",
    oldCourseSlug: "nodejs",
    newCourseSlug: "nodejs-api-development",
    lessonSlug: "nd-dev-loop",
  },
  {
    oldKey: "nodejs/nd-ch3-build",
    newKey: "nodejs-api-development/nd-ch3-build",
    oldCourseSlug: "nodejs",
    newCourseSlug: "nodejs-api-development",
    lessonSlug: "nd-ch3-build",
  },
  {
    oldKey: "nodejs/nd-ch3-quiz",
    newKey: "nodejs-api-development/nd-ch3-quiz",
    oldCourseSlug: "nodejs",
    newCourseSlug: "nodejs-api-development",
    lessonSlug: "nd-ch3-quiz",
  },
  {
    oldKey: "nodejs/nd-rest-concept",
    newKey: "nodejs-api-development/nd-rest-concept",
    oldCourseSlug: "nodejs",
    newCourseSlug: "nodejs-api-development",
    lessonSlug: "nd-rest-concept",
  },
  {
    oldKey: "nodejs/nd-get-list",
    newKey: "nodejs-api-development/nd-get-list",
    oldCourseSlug: "nodejs",
    newCourseSlug: "nodejs-api-development",
    lessonSlug: "nd-get-list",
  },
  {
    oldKey: "nodejs/nd-get-detail",
    newKey: "nodejs-api-development/nd-get-detail",
    oldCourseSlug: "nodejs",
    newCourseSlug: "nodejs-api-development",
    lessonSlug: "nd-get-detail",
  },
  {
    oldKey: "nodejs/nd-post",
    newKey: "nodejs-api-development/nd-post",
    oldCourseSlug: "nodejs",
    newCourseSlug: "nodejs-api-development",
    lessonSlug: "nd-post",
  },
  {
    oldKey: "nodejs/nd-put-delete",
    newKey: "nodejs-api-development/nd-put-delete",
    oldCourseSlug: "nodejs",
    newCourseSlug: "nodejs-api-development",
    lessonSlug: "nd-put-delete",
  },
  {
    oldKey: "nodejs/nd-status-codes",
    newKey: "nodejs-api-development/nd-status-codes",
    oldCourseSlug: "nodejs",
    newCourseSlug: "nodejs-api-development",
    lessonSlug: "nd-status-codes",
  },
  {
    oldKey: "nodejs/nd-ch4-build",
    newKey: "nodejs-api-development/nd-ch4-build",
    oldCourseSlug: "nodejs",
    newCourseSlug: "nodejs-api-development",
    lessonSlug: "nd-ch4-build",
  },
  {
    oldKey: "nodejs/nd-ch4-quiz",
    newKey: "nodejs-api-development/nd-ch4-quiz",
    oldCourseSlug: "nodejs",
    newCourseSlug: "nodejs-api-development",
    lessonSlug: "nd-ch4-quiz",
  },
  {
    oldKey: "nodejs/nd-query-params",
    newKey: "nodejs-backend-practical/nd-query-params",
    oldCourseSlug: "nodejs",
    newCourseSlug: "nodejs-backend-practical",
    lessonSlug: "nd-query-params",
  },
  {
    oldKey: "nodejs/nd-sort-paging",
    newKey: "nodejs-backend-practical/nd-sort-paging",
    oldCourseSlug: "nodejs",
    newCourseSlug: "nodejs-backend-practical",
    lessonSlug: "nd-sort-paging",
  },
  {
    oldKey: "nodejs/nd-validation",
    newKey: "nodejs-backend-practical/nd-validation",
    oldCourseSlug: "nodejs",
    newCourseSlug: "nodejs-backend-practical",
    lessonSlug: "nd-validation",
  },
  {
    oldKey: "nodejs/nd-middleware",
    newKey: "nodejs-backend-practical/nd-middleware",
    oldCourseSlug: "nodejs",
    newCourseSlug: "nodejs-backend-practical",
    lessonSlug: "nd-middleware",
  },
  {
    oldKey: "nodejs/nd-error-handling",
    newKey: "nodejs-backend-practical/nd-error-handling",
    oldCourseSlug: "nodejs",
    newCourseSlug: "nodejs-backend-practical",
    lessonSlug: "nd-error-handling",
  },
  {
    oldKey: "nodejs/nd-ch5-build",
    newKey: "nodejs-backend-practical/nd-ch5-build",
    oldCourseSlug: "nodejs",
    newCourseSlug: "nodejs-backend-practical",
    lessonSlug: "nd-ch5-build",
  },
  {
    oldKey: "nodejs/nd-ch5-quiz",
    newKey: "nodejs-backend-practical/nd-ch5-quiz",
    oldCourseSlug: "nodejs",
    newCourseSlug: "nodejs-backend-practical",
    lessonSlug: "nd-ch5-quiz",
  },
  {
    oldKey: "nodejs/nd-db-connect",
    newKey: "nodejs-backend-practical/nd-db-connect",
    oldCourseSlug: "nodejs",
    newCourseSlug: "nodejs-backend-practical",
    lessonSlug: "nd-db-connect",
  },
  {
    oldKey: "nodejs/nd-select-api",
    newKey: "nodejs-backend-practical/nd-select-api",
    oldCourseSlug: "nodejs",
    newCourseSlug: "nodejs-backend-practical",
    lessonSlug: "nd-select-api",
  },
  {
    oldKey: "nodejs/nd-insert-api",
    newKey: "nodejs-backend-practical/nd-insert-api",
    oldCourseSlug: "nodejs",
    newCourseSlug: "nodejs-backend-practical",
    lessonSlug: "nd-insert-api",
  },
  {
    oldKey: "nodejs/nd-sql-injection",
    newKey: "nodejs-backend-practical/nd-sql-injection",
    oldCourseSlug: "nodejs",
    newCourseSlug: "nodejs-backend-practical",
    lessonSlug: "nd-sql-injection",
  },
  {
    oldKey: "nodejs/nd-update-delete-api",
    newKey: "nodejs-backend-practical/nd-update-delete-api",
    oldCourseSlug: "nodejs",
    newCourseSlug: "nodejs-backend-practical",
    lessonSlug: "nd-update-delete-api",
  },
  {
    oldKey: "nodejs/nd-transaction-buy",
    newKey: "nodejs-backend-practical/nd-transaction-buy",
    oldCourseSlug: "nodejs",
    newCourseSlug: "nodejs-backend-practical",
    lessonSlug: "nd-transaction-buy",
  },
  {
    oldKey: "nodejs/nd-ch6-build",
    newKey: "nodejs-backend-practical/nd-ch6-build",
    oldCourseSlug: "nodejs",
    newCourseSlug: "nodejs-backend-practical",
    lessonSlug: "nd-ch6-build",
  },
  {
    oldKey: "nodejs/nd-ch6-quiz",
    newKey: "nodejs-backend-practical/nd-ch6-quiz",
    oldCourseSlug: "nodejs",
    newCourseSlug: "nodejs-backend-practical",
    lessonSlug: "nd-ch6-quiz",
  },
  {
    oldKey: "nodejs/nd-auth-concept",
    newKey: "nodejs-auth-production/nd-auth-concept",
    oldCourseSlug: "nodejs",
    newCourseSlug: "nodejs-auth-production",
    lessonSlug: "nd-auth-concept",
  },
  {
    oldKey: "nodejs/nd-password-hash",
    newKey: "nodejs-auth-production/nd-password-hash",
    oldCourseSlug: "nodejs",
    newCourseSlug: "nodejs-auth-production",
    lessonSlug: "nd-password-hash",
  },
  {
    oldKey: "nodejs/nd-login-token",
    newKey: "nodejs-auth-production/nd-login-token",
    oldCourseSlug: "nodejs",
    newCourseSlug: "nodejs-auth-production",
    lessonSlug: "nd-login-token",
  },
  {
    oldKey: "nodejs/nd-protected-routes",
    newKey: "nodejs-auth-production/nd-protected-routes",
    oldCourseSlug: "nodejs",
    newCourseSlug: "nodejs-auth-production",
    lessonSlug: "nd-protected-routes",
  },
  {
    oldKey: "nodejs/nd-ownership",
    newKey: "nodejs-auth-production/nd-ownership",
    oldCourseSlug: "nodejs",
    newCourseSlug: "nodejs-auth-production",
    lessonSlug: "nd-ownership",
  },
  {
    oldKey: "nodejs/nd-ch7-build",
    newKey: "nodejs-auth-production/nd-ch7-build",
    oldCourseSlug: "nodejs",
    newCourseSlug: "nodejs-auth-production",
    lessonSlug: "nd-ch7-build",
  },
  {
    oldKey: "nodejs/nd-ch7-quiz",
    newKey: "nodejs-auth-production/nd-ch7-quiz",
    oldCourseSlug: "nodejs",
    newCourseSlug: "nodejs-auth-production",
    lessonSlug: "nd-ch7-quiz",
  },
  {
    oldKey: "nodejs/nd-final-api",
    newKey: "nodejs-auth-production/nd-final-api",
    oldCourseSlug: "nodejs",
    newCourseSlug: "nodejs-auth-production",
    lessonSlug: "nd-final-api",
  },
  {
    oldKey: "nodejs/nd-final-connect-react",
    newKey: "nodejs-auth-production/nd-final-connect-react",
    oldCourseSlug: "nodejs",
    newCourseSlug: "nodejs-auth-production",
    lessonSlug: "nd-final-connect-react",
  },
  {
    oldKey: "nodejs/nd-final-deploy",
    newKey: "nodejs-auth-production/nd-final-deploy",
    oldCourseSlug: "nodejs",
    newCourseSlug: "nodejs-auth-production",
    lessonSlug: "nd-final-deploy",
  },
  {
    oldKey: "nodejs/nd-final-extend",
    newKey: "nodejs-auth-production/nd-final-extend",
    oldCourseSlug: "nodejs",
    newCourseSlug: "nodejs-auth-production",
    lessonSlug: "nd-final-extend",
  },
  {
    oldKey: "nodejs/nd-final-next",
    newKey: "nodejs-auth-production/nd-final-next",
    oldCourseSlug: "nodejs",
    newCourseSlug: "nodejs-auth-production",
    lessonSlug: "nd-final-next",
  },
  {
    oldKey: "c-basics/c-if-basics",
    newKey: "c-control-flow/c-if-basics",
    oldCourseSlug: "c-basics",
    newCourseSlug: "c-control-flow",
    lessonSlug: "c-if-basics",
  },
  {
    oldKey: "c-basics/c-else-if",
    newKey: "c-control-flow/c-else-if",
    oldCourseSlug: "c-basics",
    newCourseSlug: "c-control-flow",
    lessonSlug: "c-else-if",
  },
  {
    oldKey: "c-basics/c-switch",
    newKey: "c-control-flow/c-switch",
    oldCourseSlug: "c-basics",
    newCourseSlug: "c-control-flow",
    lessonSlug: "c-switch",
  },
  {
    oldKey: "c-basics/c-ternary",
    newKey: "c-control-flow/c-ternary",
    oldCourseSlug: "c-basics",
    newCourseSlug: "c-control-flow",
    lessonSlug: "c-ternary",
  },
  {
    oldKey: "c-basics/c-fizzbuzz-if",
    newKey: "c-control-flow/c-fizzbuzz-if",
    oldCourseSlug: "c-basics",
    newCourseSlug: "c-control-flow",
    lessonSlug: "c-fizzbuzz-if",
  },
  {
    oldKey: "c-basics/c-nested-cond",
    newKey: "c-control-flow/c-nested-cond",
    oldCourseSlug: "c-basics",
    newCourseSlug: "c-control-flow",
    lessonSlug: "c-nested-cond",
  },
  {
    oldKey: "c-basics/c-ch3-build",
    newKey: "c-control-flow/c-ch3-build",
    oldCourseSlug: "c-basics",
    newCourseSlug: "c-control-flow",
    lessonSlug: "c-ch3-build",
  },
  {
    oldKey: "c-basics/c-ch3-quiz",
    newKey: "c-control-flow/c-ch3-quiz",
    oldCourseSlug: "c-basics",
    newCourseSlug: "c-control-flow",
    lessonSlug: "c-ch3-quiz",
  },
  {
    oldKey: "c-basics/c-for-basics",
    newKey: "c-control-flow/c-for-basics",
    oldCourseSlug: "c-basics",
    newCourseSlug: "c-control-flow",
    lessonSlug: "c-for-basics",
  },
  {
    oldKey: "c-basics/c-while-loop",
    newKey: "c-control-flow/c-while-loop",
    oldCourseSlug: "c-basics",
    newCourseSlug: "c-control-flow",
    lessonSlug: "c-while-loop",
  },
  {
    oldKey: "c-basics/c-do-while",
    newKey: "c-control-flow/c-do-while",
    oldCourseSlug: "c-basics",
    newCourseSlug: "c-control-flow",
    lessonSlug: "c-do-while",
  },
  {
    oldKey: "c-basics/c-break-continue",
    newKey: "c-control-flow/c-break-continue",
    oldCourseSlug: "c-basics",
    newCourseSlug: "c-control-flow",
    lessonSlug: "c-break-continue",
  },
  {
    oldKey: "c-basics/c-kuku",
    newKey: "c-control-flow/c-kuku",
    oldCourseSlug: "c-basics",
    newCourseSlug: "c-control-flow",
    lessonSlug: "c-kuku",
  },
  {
    oldKey: "c-basics/c-fizzbuzz-loop",
    newKey: "c-control-flow/c-fizzbuzz-loop",
    oldCourseSlug: "c-basics",
    newCourseSlug: "c-control-flow",
    lessonSlug: "c-fizzbuzz-loop",
  },
  {
    oldKey: "c-basics/c-ch4-build",
    newKey: "c-control-flow/c-ch4-build",
    oldCourseSlug: "c-basics",
    newCourseSlug: "c-control-flow",
    lessonSlug: "c-ch4-build",
  },
  {
    oldKey: "c-basics/c-ch4-quiz",
    newKey: "c-control-flow/c-ch4-quiz",
    oldCourseSlug: "c-basics",
    newCourseSlug: "c-control-flow",
    lessonSlug: "c-ch4-quiz",
  },
  {
    oldKey: "c-basics/c-function-def",
    newKey: "c-functions-arrays/c-function-def",
    oldCourseSlug: "c-basics",
    newCourseSlug: "c-functions-arrays",
    lessonSlug: "c-function-def",
  },
  {
    oldKey: "c-basics/c-args-return",
    newKey: "c-functions-arrays/c-args-return",
    oldCourseSlug: "c-basics",
    newCourseSlug: "c-functions-arrays",
    lessonSlug: "c-args-return",
  },
  {
    oldKey: "c-basics/c-prototypes",
    newKey: "c-functions-arrays/c-prototypes",
    oldCourseSlug: "c-basics",
    newCourseSlug: "c-functions-arrays",
    lessonSlug: "c-prototypes",
  },
  {
    oldKey: "c-basics/c-void-func",
    newKey: "c-functions-arrays/c-void-func",
    oldCourseSlug: "c-basics",
    newCourseSlug: "c-functions-arrays",
    lessonSlug: "c-void-func",
  },
  {
    oldKey: "c-basics/c-scope-c",
    newKey: "c-functions-arrays/c-scope-c",
    oldCourseSlug: "c-basics",
    newCourseSlug: "c-functions-arrays",
    lessonSlug: "c-scope-c",
  },
  {
    oldKey: "c-basics/c-ch5-build",
    newKey: "c-functions-arrays/c-ch5-build",
    oldCourseSlug: "c-basics",
    newCourseSlug: "c-functions-arrays",
    lessonSlug: "c-ch5-build",
  },
  {
    oldKey: "c-basics/c-ch5-quiz",
    newKey: "c-functions-arrays/c-ch5-quiz",
    oldCourseSlug: "c-basics",
    newCourseSlug: "c-functions-arrays",
    lessonSlug: "c-ch5-quiz",
  },
  {
    oldKey: "c-basics/c-arrays",
    newKey: "c-functions-arrays/c-arrays",
    oldCourseSlug: "c-basics",
    newCourseSlug: "c-functions-arrays",
    lessonSlug: "c-arrays",
  },
  {
    oldKey: "c-basics/c-array-loop",
    newKey: "c-functions-arrays/c-array-loop",
    oldCourseSlug: "c-basics",
    newCourseSlug: "c-functions-arrays",
    lessonSlug: "c-array-loop",
  },
  {
    oldKey: "c-basics/c-array-aggregate",
    newKey: "c-functions-arrays/c-array-aggregate",
    oldCourseSlug: "c-basics",
    newCourseSlug: "c-functions-arrays",
    lessonSlug: "c-array-aggregate",
  },
  {
    oldKey: "c-basics/c-array-max-min",
    newKey: "c-functions-arrays/c-array-max-min",
    oldCourseSlug: "c-basics",
    newCourseSlug: "c-functions-arrays",
    lessonSlug: "c-array-max-min",
  },
  {
    oldKey: "c-basics/c-strings",
    newKey: "c-functions-arrays/c-strings",
    oldCourseSlug: "c-basics",
    newCourseSlug: "c-functions-arrays",
    lessonSlug: "c-strings",
  },
  {
    oldKey: "c-basics/c-string-funcs",
    newKey: "c-functions-arrays/c-string-funcs",
    oldCourseSlug: "c-basics",
    newCourseSlug: "c-functions-arrays",
    lessonSlug: "c-string-funcs",
  },
  {
    oldKey: "c-basics/c-string-input",
    newKey: "c-functions-arrays/c-string-input",
    oldCourseSlug: "c-basics",
    newCourseSlug: "c-functions-arrays",
    lessonSlug: "c-string-input",
  },
  {
    oldKey: "c-basics/c-ch6-build",
    newKey: "c-functions-arrays/c-ch6-build",
    oldCourseSlug: "c-basics",
    newCourseSlug: "c-functions-arrays",
    lessonSlug: "c-ch6-build",
  },
  {
    oldKey: "c-basics/c-ch6-quiz",
    newKey: "c-functions-arrays/c-ch6-quiz",
    oldCourseSlug: "c-basics",
    newCourseSlug: "c-functions-arrays",
    lessonSlug: "c-ch6-quiz",
  },
  {
    oldKey: "c-basics/c-what-is-address",
    newKey: "c-pointers-structs-files/c-what-is-address",
    oldCourseSlug: "c-basics",
    newCourseSlug: "c-pointers-structs-files",
    lessonSlug: "c-what-is-address",
  },
  {
    oldKey: "c-basics/c-pointer-basics",
    newKey: "c-pointers-structs-files/c-pointer-basics",
    oldCourseSlug: "c-basics",
    newCourseSlug: "c-pointers-structs-files",
    lessonSlug: "c-pointer-basics",
  },
  {
    oldKey: "c-basics/c-scanf-revealed",
    newKey: "c-pointers-structs-files/c-scanf-revealed",
    oldCourseSlug: "c-basics",
    newCourseSlug: "c-pointers-structs-files",
    lessonSlug: "c-scanf-revealed",
  },
  {
    oldKey: "c-basics/c-pointer-args",
    newKey: "c-pointers-structs-files/c-pointer-args",
    oldCourseSlug: "c-basics",
    newCourseSlug: "c-pointers-structs-files",
    lessonSlug: "c-pointer-args",
  },
  {
    oldKey: "c-basics/c-array-to-func",
    newKey: "c-pointers-structs-files/c-array-to-func",
    oldCourseSlug: "c-basics",
    newCourseSlug: "c-pointers-structs-files",
    lessonSlug: "c-array-to-func",
  },
  {
    oldKey: "c-basics/c-ch7-build",
    newKey: "c-pointers-structs-files/c-ch7-build",
    oldCourseSlug: "c-basics",
    newCourseSlug: "c-pointers-structs-files",
    lessonSlug: "c-ch7-build",
  },
  {
    oldKey: "c-basics/c-ch7-quiz",
    newKey: "c-pointers-structs-files/c-ch7-quiz",
    oldCourseSlug: "c-basics",
    newCourseSlug: "c-pointers-structs-files",
    lessonSlug: "c-ch7-quiz",
  },
  {
    oldKey: "c-basics/c-struct-basics",
    newKey: "c-pointers-structs-files/c-struct-basics",
    oldCourseSlug: "c-basics",
    newCourseSlug: "c-pointers-structs-files",
    lessonSlug: "c-struct-basics",
  },
  {
    oldKey: "c-basics/c-struct-members",
    newKey: "c-pointers-structs-files/c-struct-members",
    oldCourseSlug: "c-basics",
    newCourseSlug: "c-pointers-structs-files",
    lessonSlug: "c-struct-members",
  },
  {
    oldKey: "c-basics/c-struct-array",
    newKey: "c-pointers-structs-files/c-struct-array",
    oldCourseSlug: "c-basics",
    newCourseSlug: "c-pointers-structs-files",
    lessonSlug: "c-struct-array",
  },
  {
    oldKey: "c-basics/c-struct-func",
    newKey: "c-pointers-structs-files/c-struct-func",
    oldCourseSlug: "c-basics",
    newCourseSlug: "c-pointers-structs-files",
    lessonSlug: "c-struct-func",
  },
  {
    oldKey: "c-basics/c-file-write",
    newKey: "c-pointers-structs-files/c-file-write",
    oldCourseSlug: "c-basics",
    newCourseSlug: "c-pointers-structs-files",
    lessonSlug: "c-file-write",
  },
  {
    oldKey: "c-basics/c-file-read",
    newKey: "c-pointers-structs-files/c-file-read",
    oldCourseSlug: "c-basics",
    newCourseSlug: "c-pointers-structs-files",
    lessonSlug: "c-file-read",
  },
  {
    oldKey: "c-basics/c-file-check",
    newKey: "c-pointers-structs-files/c-file-check",
    oldCourseSlug: "c-basics",
    newCourseSlug: "c-pointers-structs-files",
    lessonSlug: "c-file-check",
  },
  {
    oldKey: "c-basics/c-ch8-build",
    newKey: "c-pointers-structs-files/c-ch8-build",
    oldCourseSlug: "c-basics",
    newCourseSlug: "c-pointers-structs-files",
    lessonSlug: "c-ch8-build",
  },
  {
    oldKey: "c-basics/c-ch8-quiz",
    newKey: "c-pointers-structs-files/c-ch8-quiz",
    oldCourseSlug: "c-basics",
    newCourseSlug: "c-pointers-structs-files",
    lessonSlug: "c-ch8-quiz",
  },
  {
    oldKey: "c-basics/c-final-integrate",
    newKey: "c-pointers-structs-files/c-final-integrate",
    oldCourseSlug: "c-basics",
    newCourseSlug: "c-pointers-structs-files",
    lessonSlug: "c-final-integrate",
  },
  {
    oldKey: "c-basics/c-final-extend",
    newKey: "c-pointers-structs-files/c-final-extend",
    oldCourseSlug: "c-basics",
    newCourseSlug: "c-pointers-structs-files",
    lessonSlug: "c-final-extend",
  },
  {
    oldKey: "c-basics/c-final-next",
    newKey: "c-pointers-structs-files/c-final-next",
    oldCourseSlug: "c-basics",
    newCourseSlug: "c-pointers-structs-files",
    lessonSlug: "c-final-next",
  },
  {
    oldKey: "c-intermediate/c2-strlen-impl",
    newKey: "c-strings-structures/c2-strlen-impl",
    oldCourseSlug: "c-intermediate",
    newCourseSlug: "c-strings-structures",
    lessonSlug: "c2-strlen-impl",
  },
  {
    oldKey: "c-intermediate/c2-strcpy-impl",
    newKey: "c-strings-structures/c2-strcpy-impl",
    oldCourseSlug: "c-intermediate",
    newCourseSlug: "c-strings-structures",
    lessonSlug: "c2-strcpy-impl",
  },
  {
    oldKey: "c-intermediate/c2-buffer-overflow",
    newKey: "c-strings-structures/c2-buffer-overflow",
    oldCourseSlug: "c-intermediate",
    newCourseSlug: "c-strings-structures",
    lessonSlug: "c2-buffer-overflow",
  },
  {
    oldKey: "c-intermediate/c2-string-parse",
    newKey: "c-strings-structures/c2-string-parse",
    oldCourseSlug: "c-intermediate",
    newCourseSlug: "c-strings-structures",
    lessonSlug: "c2-string-parse",
  },
  {
    oldKey: "c-intermediate/c2-dynamic-strings",
    newKey: "c-strings-structures/c2-dynamic-strings",
    oldCourseSlug: "c-intermediate",
    newCourseSlug: "c-strings-structures",
    lessonSlug: "c2-dynamic-strings",
  },
  {
    oldKey: "c-intermediate/c2-ch3-build",
    newKey: "c-strings-structures/c2-ch3-build",
    oldCourseSlug: "c-intermediate",
    newCourseSlug: "c-strings-structures",
    lessonSlug: "c2-ch3-build",
  },
  {
    oldKey: "c-intermediate/c2-ch3-quiz",
    newKey: "c-strings-structures/c2-ch3-quiz",
    oldCourseSlug: "c-intermediate",
    newCourseSlug: "c-strings-structures",
    lessonSlug: "c2-ch3-quiz",
  },
  {
    oldKey: "c-intermediate/c2-struct-pointer-arrow",
    newKey: "c-strings-structures/c2-struct-pointer-arrow",
    oldCourseSlug: "c-intermediate",
    newCourseSlug: "c-strings-structures",
    lessonSlug: "c2-struct-pointer-arrow",
  },
  {
    oldKey: "c-intermediate/c2-dynamic-struct",
    newKey: "c-strings-structures/c2-dynamic-struct",
    oldCourseSlug: "c-intermediate",
    newCourseSlug: "c-strings-structures",
    lessonSlug: "c2-dynamic-struct",
  },
  {
    oldKey: "c-intermediate/c2-struct-array-dynamic",
    newKey: "c-strings-structures/c2-struct-array-dynamic",
    oldCourseSlug: "c-intermediate",
    newCourseSlug: "c-strings-structures",
    lessonSlug: "c2-struct-array-dynamic",
  },
  {
    oldKey: "c-intermediate/c2-function-pointers",
    newKey: "c-strings-structures/c2-function-pointers",
    oldCourseSlug: "c-intermediate",
    newCourseSlug: "c-strings-structures",
    lessonSlug: "c2-function-pointers",
  },
  {
    oldKey: "c-intermediate/c2-qsort-usage",
    newKey: "c-strings-structures/c2-qsort-usage",
    oldCourseSlug: "c-intermediate",
    newCourseSlug: "c-strings-structures",
    lessonSlug: "c2-qsort-usage",
  },
  {
    oldKey: "c-intermediate/c2-ch4-build",
    newKey: "c-strings-structures/c2-ch4-build",
    oldCourseSlug: "c-intermediate",
    newCourseSlug: "c-strings-structures",
    lessonSlug: "c2-ch4-build",
  },
  {
    oldKey: "c-intermediate/c2-ch4-quiz",
    newKey: "c-strings-structures/c2-ch4-quiz",
    oldCourseSlug: "c-intermediate",
    newCourseSlug: "c-strings-structures",
    lessonSlug: "c2-ch4-quiz",
  },
  {
    oldKey: "c-intermediate/c2-why-list",
    newKey: "c-linked-list-applications/c2-why-list",
    oldCourseSlug: "c-intermediate",
    newCourseSlug: "c-linked-list-applications",
    lessonSlug: "c2-why-list",
  },
  {
    oldKey: "c-intermediate/c2-node-define",
    newKey: "c-linked-list-applications/c2-node-define",
    oldCourseSlug: "c-intermediate",
    newCourseSlug: "c-linked-list-applications",
    lessonSlug: "c2-node-define",
  },
  {
    oldKey: "c-intermediate/c2-insert-head",
    newKey: "c-linked-list-applications/c2-insert-head",
    oldCourseSlug: "c-intermediate",
    newCourseSlug: "c-linked-list-applications",
    lessonSlug: "c2-insert-head",
  },
  {
    oldKey: "c-intermediate/c2-traverse-list",
    newKey: "c-linked-list-applications/c2-traverse-list",
    oldCourseSlug: "c-intermediate",
    newCourseSlug: "c-linked-list-applications",
    lessonSlug: "c2-traverse-list",
  },
  {
    oldKey: "c-intermediate/c2-insert-delete-any",
    newKey: "c-linked-list-applications/c2-insert-delete-any",
    oldCourseSlug: "c-intermediate",
    newCourseSlug: "c-linked-list-applications",
    lessonSlug: "c2-insert-delete-any",
  },
  {
    oldKey: "c-intermediate/c2-free-list",
    newKey: "c-linked-list-applications/c2-free-list",
    oldCourseSlug: "c-intermediate",
    newCourseSlug: "c-linked-list-applications",
    lessonSlug: "c2-free-list",
  },
  {
    oldKey: "c-intermediate/c2-ch5-build",
    newKey: "c-linked-list-applications/c2-ch5-build",
    oldCourseSlug: "c-intermediate",
    newCourseSlug: "c-linked-list-applications",
    lessonSlug: "c2-ch5-build",
  },
  {
    oldKey: "c-intermediate/c2-ch5-quiz",
    newKey: "c-linked-list-applications/c2-ch5-quiz",
    oldCourseSlug: "c-intermediate",
    newCourseSlug: "c-linked-list-applications",
    lessonSlug: "c2-ch5-quiz",
  },
  {
    oldKey: "c-intermediate/c2-dynamic-2d",
    newKey: "c-linked-list-applications/c2-dynamic-2d",
    oldCourseSlug: "c-intermediate",
    newCourseSlug: "c-linked-list-applications",
    lessonSlug: "c2-dynamic-2d",
  },
  {
    oldKey: "c-intermediate/c2-argv",
    newKey: "c-linked-list-applications/c2-argv",
    oldCourseSlug: "c-intermediate",
    newCourseSlug: "c-linked-list-applications",
    lessonSlug: "c2-argv",
  },
  {
    oldKey: "c-intermediate/c2-binary-files",
    newKey: "c-linked-list-applications/c2-binary-files",
    oldCourseSlug: "c-intermediate",
    newCourseSlug: "c-linked-list-applications",
    lessonSlug: "c2-binary-files",
  },
  {
    oldKey: "c-intermediate/c2-errno-basics",
    newKey: "c-linked-list-applications/c2-errno-basics",
    oldCourseSlug: "c-intermediate",
    newCourseSlug: "c-linked-list-applications",
    lessonSlug: "c2-errno-basics",
  },
  {
    oldKey: "c-intermediate/c2-ch6-build",
    newKey: "c-linked-list-applications/c2-ch6-build",
    oldCourseSlug: "c-intermediate",
    newCourseSlug: "c-linked-list-applications",
    lessonSlug: "c2-ch6-build",
  },
  {
    oldKey: "c-intermediate/c2-ch6-quiz",
    newKey: "c-linked-list-applications/c2-ch6-quiz",
    oldCourseSlug: "c-intermediate",
    newCourseSlug: "c-linked-list-applications",
    lessonSlug: "c2-ch6-quiz",
  },
  {
    oldKey: "c-intermediate/c2-final-rebuild",
    newKey: "c-linked-list-applications/c2-final-rebuild",
    oldCourseSlug: "c-intermediate",
    newCourseSlug: "c-linked-list-applications",
    lessonSlug: "c2-final-rebuild",
  },
  {
    oldKey: "c-intermediate/c2-final-memory-debug",
    newKey: "c-linked-list-applications/c2-final-memory-debug",
    oldCourseSlug: "c-intermediate",
    newCourseSlug: "c-linked-list-applications",
    lessonSlug: "c2-final-memory-debug",
  },
  {
    oldKey: "c-intermediate/c2-final-extend",
    newKey: "c-linked-list-applications/c2-final-extend",
    oldCourseSlug: "c-intermediate",
    newCourseSlug: "c-linked-list-applications",
    lessonSlug: "c2-final-extend",
  },
  {
    oldKey: "c-intermediate/c2-final-next",
    newKey: "c-linked-list-applications/c2-final-next",
    oldCourseSlug: "c-intermediate",
    newCourseSlug: "c-linked-list-applications",
    lessonSlug: "c2-final-next",
  },
  {
    oldKey: "python-basics/py-comparison",
    newKey: "python-operators-control/py-comparison",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-operators-control",
    lessonSlug: "py-comparison",
  },
  {
    oldKey: "python-basics/py-logical",
    newKey: "python-operators-control/py-logical",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-operators-control",
    lessonSlug: "py-logical",
  },
  {
    oldKey: "python-basics/py-in-operator",
    newKey: "python-operators-control/py-in-operator",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-operators-control",
    lessonSlug: "py-in-operator",
  },
  {
    oldKey: "python-basics/py-modulo",
    newKey: "python-operators-control/py-modulo",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-operators-control",
    lessonSlug: "py-modulo",
  },
  {
    oldKey: "python-basics/py-chained-priority",
    newKey: "python-operators-control/py-chained-priority",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-operators-control",
    lessonSlug: "py-chained-priority",
  },
  {
    oldKey: "python-basics/py-ternary",
    newKey: "python-operators-control/py-ternary",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-operators-control",
    lessonSlug: "py-ternary",
  },
  {
    oldKey: "python-basics/py-ch3-build",
    newKey: "python-operators-control/py-ch3-build",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-operators-control",
    lessonSlug: "py-ch3-build",
  },
  {
    oldKey: "python-basics/py-ch3-quiz",
    newKey: "python-operators-control/py-ch3-quiz",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-operators-control",
    lessonSlug: "py-ch3-quiz",
  },
  {
    oldKey: "python-basics/py-if-basics",
    newKey: "python-operators-control/py-if-basics",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-operators-control",
    lessonSlug: "py-if-basics",
  },
  {
    oldKey: "python-basics/py-if-elif-else",
    newKey: "python-operators-control/py-if-elif-else",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-operators-control",
    lessonSlug: "py-if-elif-else",
  },
  {
    oldKey: "python-basics/py-nested-if",
    newKey: "python-operators-control/py-nested-if",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-operators-control",
    lessonSlug: "py-nested-if",
  },
  {
    oldKey: "python-basics/py-match",
    newKey: "python-operators-control/py-match",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-operators-control",
    lessonSlug: "py-match",
  },
  {
    oldKey: "python-basics/py-fizzbuzz",
    newKey: "python-operators-control/py-fizzbuzz",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-operators-control",
    lessonSlug: "py-fizzbuzz",
  },
  {
    oldKey: "python-basics/py-default-or",
    newKey: "python-operators-control/py-default-or",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-operators-control",
    lessonSlug: "py-default-or",
  },
  {
    oldKey: "python-basics/py-ch4-build",
    newKey: "python-operators-control/py-ch4-build",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-operators-control",
    lessonSlug: "py-ch4-build",
  },
  {
    oldKey: "python-basics/py-ch4-quiz",
    newKey: "python-operators-control/py-ch4-quiz",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-operators-control",
    lessonSlug: "py-ch4-quiz",
  },
  {
    oldKey: "python-basics/py-for-sum",
    newKey: "python-loops-functions/py-for-sum",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-loops-functions",
    lessonSlug: "py-for-sum",
  },
  {
    oldKey: "python-basics/py-while-loop",
    newKey: "python-loops-functions/py-while-loop",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-loops-functions",
    lessonSlug: "py-while-loop",
  },
  {
    oldKey: "python-basics/py-range-step",
    newKey: "python-loops-functions/py-range-step",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-loops-functions",
    lessonSlug: "py-range-step",
  },
  {
    oldKey: "python-basics/py-break-continue",
    newKey: "python-loops-functions/py-break-continue",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-loops-functions",
    lessonSlug: "py-break-continue",
  },
  {
    oldKey: "python-basics/py-enumerate",
    newKey: "python-loops-functions/py-enumerate",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-loops-functions",
    lessonSlug: "py-enumerate",
  },
  {
    oldKey: "python-basics/py-zip",
    newKey: "python-loops-functions/py-zip",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-loops-functions",
    lessonSlug: "py-zip",
  },
  {
    oldKey: "python-basics/py-nested-loop",
    newKey: "python-loops-functions/py-nested-loop",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-loops-functions",
    lessonSlug: "py-nested-loop",
  },
  {
    oldKey: "python-basics/py-ch5-build",
    newKey: "python-loops-functions/py-ch5-build",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-loops-functions",
    lessonSlug: "py-ch5-build",
  },
  {
    oldKey: "python-basics/py-ch5-quiz",
    newKey: "python-loops-functions/py-ch5-quiz",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-loops-functions",
    lessonSlug: "py-ch5-quiz",
  },
  {
    oldKey: "python-basics/py-def-basics",
    newKey: "python-loops-functions/py-def-basics",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-loops-functions",
    lessonSlug: "py-def-basics",
  },
  {
    oldKey: "python-basics/py-args-return",
    newKey: "python-loops-functions/py-args-return",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-loops-functions",
    lessonSlug: "py-args-return",
  },
  {
    oldKey: "python-basics/py-default-args",
    newKey: "python-loops-functions/py-default-args",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-loops-functions",
    lessonSlug: "py-default-args",
  },
  {
    oldKey: "python-basics/py-keyword-args",
    newKey: "python-loops-functions/py-keyword-args",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-loops-functions",
    lessonSlug: "py-keyword-args",
  },
  {
    oldKey: "python-basics/py-multiple-return",
    newKey: "python-loops-functions/py-multiple-return",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-loops-functions",
    lessonSlug: "py-multiple-return",
  },
  {
    oldKey: "python-basics/py-divmod",
    newKey: "python-loops-functions/py-divmod",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-loops-functions",
    lessonSlug: "py-divmod",
  },
  {
    oldKey: "python-basics/py-scope",
    newKey: "python-loops-functions/py-scope",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-loops-functions",
    lessonSlug: "py-scope",
  },
  {
    oldKey: "python-basics/py-lambda",
    newKey: "python-loops-functions/py-lambda",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-loops-functions",
    lessonSlug: "py-lambda",
  },
  {
    oldKey: "python-basics/py-ch6-build",
    newKey: "python-loops-functions/py-ch6-build",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-loops-functions",
    lessonSlug: "py-ch6-build",
  },
  {
    oldKey: "python-basics/py-ch6-quiz",
    newKey: "python-loops-functions/py-ch6-quiz",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-loops-functions",
    lessonSlug: "py-ch6-quiz",
  },
  {
    oldKey: "python-basics/py-list-methods",
    newKey: "python-collections/py-list-methods",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-collections",
    lessonSlug: "py-list-methods",
  },
  {
    oldKey: "python-basics/py-slicing",
    newKey: "python-collections/py-slicing",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-collections",
    lessonSlug: "py-slicing",
  },
  {
    oldKey: "python-basics/py-dict-basics",
    newKey: "python-collections/py-dict-basics",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-collections",
    lessonSlug: "py-dict-basics",
  },
  {
    oldKey: "python-basics/py-dict-loop",
    newKey: "python-collections/py-dict-loop",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-collections",
    lessonSlug: "py-dict-loop",
  },
  {
    oldKey: "python-basics/py-sort-key",
    newKey: "python-collections/py-sort-key",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-collections",
    lessonSlug: "py-sort-key",
  },
  {
    oldKey: "python-basics/py-set-dedup",
    newKey: "python-collections/py-set-dedup",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-collections",
    lessonSlug: "py-set-dedup",
  },
  {
    oldKey: "python-basics/py-list-comprehension",
    newKey: "python-collections/py-list-comprehension",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-collections",
    lessonSlug: "py-list-comprehension",
  },
  {
    oldKey: "python-basics/py-tuple-unpack",
    newKey: "python-collections/py-tuple-unpack",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-collections",
    lessonSlug: "py-tuple-unpack",
  },
  {
    oldKey: "python-basics/py-ch7-build",
    newKey: "python-collections/py-ch7-build",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-collections",
    lessonSlug: "py-ch7-build",
  },
  {
    oldKey: "python-basics/py-ch7-quiz",
    newKey: "python-collections/py-ch7-quiz",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-collections",
    lessonSlug: "py-ch7-quiz",
  },
  {
    oldKey: "python-basics/py-file-read",
    newKey: "python-files-errors-project/py-file-read",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-files-errors-project",
    lessonSlug: "py-file-read",
  },
  {
    oldKey: "python-basics/py-file-write",
    newKey: "python-files-errors-project/py-file-write",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-files-errors-project",
    lessonSlug: "py-file-write",
  },
  {
    oldKey: "python-basics/py-with-statement",
    newKey: "python-files-errors-project/py-with-statement",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-files-errors-project",
    lessonSlug: "py-with-statement",
  },
  {
    oldKey: "python-basics/py-csv-like",
    newKey: "python-files-errors-project/py-csv-like",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-files-errors-project",
    lessonSlug: "py-csv-like",
  },
  {
    oldKey: "python-basics/py-try-except",
    newKey: "python-files-errors-project/py-try-except",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-files-errors-project",
    lessonSlug: "py-try-except",
  },
  {
    oldKey: "python-basics/py-exception-types",
    newKey: "python-files-errors-project/py-exception-types",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-files-errors-project",
    lessonSlug: "py-exception-types",
  },
  {
    oldKey: "python-basics/py-ch8-build",
    newKey: "python-files-errors-project/py-ch8-build",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-files-errors-project",
    lessonSlug: "py-ch8-build",
  },
  {
    oldKey: "python-basics/py-ch8-quiz",
    newKey: "python-files-errors-project/py-ch8-quiz",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-files-errors-project",
    lessonSlug: "py-ch8-quiz",
  },
  {
    oldKey: "python-basics/py-final-integrate",
    newKey: "python-files-errors-project/py-final-integrate",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-files-errors-project",
    lessonSlug: "py-final-integrate",
  },
  {
    oldKey: "python-basics/py-final-report",
    newKey: "python-files-errors-project/py-final-report",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-files-errors-project",
    lessonSlug: "py-final-report",
  },
  {
    oldKey: "python-basics/py-final-extend",
    newKey: "python-files-errors-project/py-final-extend",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-files-errors-project",
    lessonSlug: "py-final-extend",
  },
  {
    oldKey: "python-basics/py-final-publish",
    newKey: "python-files-errors-project/py-final-publish",
    oldCourseSlug: "python-basics",
    newCourseSlug: "python-files-errors-project",
    lessonSlug: "py-final-publish",
  },
  {
    oldKey: "python-intermediate/py2-listcomp-cond",
    newKey: "python-comprehensions-higher-order/py2-listcomp-cond",
    oldCourseSlug: "python-intermediate",
    newCourseSlug: "python-comprehensions-higher-order",
    lessonSlug: "py2-listcomp-cond",
  },
  {
    oldKey: "python-intermediate/py2-listcomp-ifelse",
    newKey: "python-comprehensions-higher-order/py2-listcomp-ifelse",
    oldCourseSlug: "python-intermediate",
    newCourseSlug: "python-comprehensions-higher-order",
    lessonSlug: "py2-listcomp-ifelse",
  },
  {
    oldKey: "python-intermediate/py2-dictcomp",
    newKey: "python-comprehensions-higher-order/py2-dictcomp",
    oldCourseSlug: "python-intermediate",
    newCourseSlug: "python-comprehensions-higher-order",
    lessonSlug: "py2-dictcomp",
  },
  {
    oldKey: "python-intermediate/py2-setcomp",
    newKey: "python-comprehensions-higher-order/py2-setcomp",
    oldCourseSlug: "python-intermediate",
    newCourseSlug: "python-comprehensions-higher-order",
    lessonSlug: "py2-setcomp",
  },
  {
    oldKey: "python-intermediate/py2-genexp",
    newKey: "python-comprehensions-higher-order/py2-genexp",
    oldCourseSlug: "python-intermediate",
    newCourseSlug: "python-comprehensions-higher-order",
    lessonSlug: "py2-genexp",
  },
  {
    oldKey: "python-intermediate/py2-ch3-build",
    newKey: "python-comprehensions-higher-order/py2-ch3-build",
    oldCourseSlug: "python-intermediate",
    newCourseSlug: "python-comprehensions-higher-order",
    lessonSlug: "py2-ch3-build",
  },
  {
    oldKey: "python-intermediate/py2-ch3-quiz",
    newKey: "python-comprehensions-higher-order/py2-ch3-quiz",
    oldCourseSlug: "python-intermediate",
    newCourseSlug: "python-comprehensions-higher-order",
    lessonSlug: "py2-ch3-quiz",
  },
  {
    oldKey: "python-intermediate/py2-func-as-value",
    newKey: "python-comprehensions-higher-order/py2-func-as-value",
    oldCourseSlug: "python-intermediate",
    newCourseSlug: "python-comprehensions-higher-order",
    lessonSlug: "py2-func-as-value",
  },
  {
    oldKey: "python-intermediate/py2-map",
    newKey: "python-comprehensions-higher-order/py2-map",
    oldCourseSlug: "python-intermediate",
    newCourseSlug: "python-comprehensions-higher-order",
    lessonSlug: "py2-map",
  },
  {
    oldKey: "python-intermediate/py2-filter",
    newKey: "python-comprehensions-higher-order/py2-filter",
    oldCourseSlug: "python-intermediate",
    newCourseSlug: "python-comprehensions-higher-order",
    lessonSlug: "py2-filter",
  },
  {
    oldKey: "python-intermediate/py2-sorted-key",
    newKey: "python-comprehensions-higher-order/py2-sorted-key",
    oldCourseSlug: "python-intermediate",
    newCourseSlug: "python-comprehensions-higher-order",
    lessonSlug: "py2-sorted-key",
  },
  {
    oldKey: "python-intermediate/py2-reduce",
    newKey: "python-comprehensions-higher-order/py2-reduce",
    oldCourseSlug: "python-intermediate",
    newCourseSlug: "python-comprehensions-higher-order",
    lessonSlug: "py2-reduce",
  },
  {
    oldKey: "python-intermediate/py2-any-all",
    newKey: "python-comprehensions-higher-order/py2-any-all",
    oldCourseSlug: "python-intermediate",
    newCourseSlug: "python-comprehensions-higher-order",
    lessonSlug: "py2-any-all",
  },
  {
    oldKey: "python-intermediate/py2-ch4-build",
    newKey: "python-comprehensions-higher-order/py2-ch4-build",
    oldCourseSlug: "python-intermediate",
    newCourseSlug: "python-comprehensions-higher-order",
    lessonSlug: "py2-ch4-build",
  },
  {
    oldKey: "python-intermediate/py2-ch4-quiz",
    newKey: "python-comprehensions-higher-order/py2-ch4-quiz",
    oldCourseSlug: "python-intermediate",
    newCourseSlug: "python-comprehensions-higher-order",
    lessonSlug: "py2-ch4-quiz",
  },
  {
    oldKey: "python-intermediate/py2-exception-hierarchy",
    newKey: "python-errors-data-formats/py2-exception-hierarchy",
    oldCourseSlug: "python-intermediate",
    newCourseSlug: "python-errors-data-formats",
    lessonSlug: "py2-exception-hierarchy",
  },
  {
    oldKey: "python-intermediate/py2-raise",
    newKey: "python-errors-data-formats/py2-raise",
    oldCourseSlug: "python-intermediate",
    newCourseSlug: "python-errors-data-formats",
    lessonSlug: "py2-raise",
  },
  {
    oldKey: "python-intermediate/py2-custom-exception",
    newKey: "python-errors-data-formats/py2-custom-exception",
    oldCourseSlug: "python-intermediate",
    newCourseSlug: "python-errors-data-formats",
    lessonSlug: "py2-custom-exception",
  },
  {
    oldKey: "python-intermediate/py2-finally-else",
    newKey: "python-errors-data-formats/py2-finally-else",
    oldCourseSlug: "python-intermediate",
    newCourseSlug: "python-errors-data-formats",
    lessonSlug: "py2-finally-else",
  },
  {
    oldKey: "python-intermediate/py2-assert",
    newKey: "python-errors-data-formats/py2-assert",
    oldCourseSlug: "python-intermediate",
    newCourseSlug: "python-errors-data-formats",
    lessonSlug: "py2-assert",
  },
  {
    oldKey: "python-intermediate/py2-ch5-build",
    newKey: "python-errors-data-formats/py2-ch5-build",
    oldCourseSlug: "python-intermediate",
    newCourseSlug: "python-errors-data-formats",
    lessonSlug: "py2-ch5-build",
  },
  {
    oldKey: "python-intermediate/py2-ch5-quiz",
    newKey: "python-errors-data-formats/py2-ch5-quiz",
    oldCourseSlug: "python-intermediate",
    newCourseSlug: "python-errors-data-formats",
    lessonSlug: "py2-ch5-quiz",
  },
  {
    oldKey: "python-intermediate/py2-csv-module",
    newKey: "python-errors-data-formats/py2-csv-module",
    oldCourseSlug: "python-intermediate",
    newCourseSlug: "python-errors-data-formats",
    lessonSlug: "py2-csv-module",
  },
  {
    oldKey: "python-intermediate/py2-json-write",
    newKey: "python-errors-data-formats/py2-json-write",
    oldCourseSlug: "python-intermediate",
    newCourseSlug: "python-errors-data-formats",
    lessonSlug: "py2-json-write",
  },
  {
    oldKey: "python-intermediate/py2-json-read",
    newKey: "python-errors-data-formats/py2-json-read",
    oldCourseSlug: "python-intermediate",
    newCourseSlug: "python-errors-data-formats",
    lessonSlug: "py2-json-read",
  },
  {
    oldKey: "python-intermediate/py2-pathlib",
    newKey: "python-errors-data-formats/py2-pathlib",
    oldCourseSlug: "python-intermediate",
    newCourseSlug: "python-errors-data-formats",
    lessonSlug: "py2-pathlib",
  },
  {
    oldKey: "python-intermediate/py2-encoding",
    newKey: "python-errors-data-formats/py2-encoding",
    oldCourseSlug: "python-intermediate",
    newCourseSlug: "python-errors-data-formats",
    lessonSlug: "py2-encoding",
  },
  {
    oldKey: "python-intermediate/py2-ch6-build",
    newKey: "python-errors-data-formats/py2-ch6-build",
    oldCourseSlug: "python-intermediate",
    newCourseSlug: "python-errors-data-formats",
    lessonSlug: "py2-ch6-build",
  },
  {
    oldKey: "python-intermediate/py2-ch6-quiz",
    newKey: "python-errors-data-formats/py2-ch6-quiz",
    oldCourseSlug: "python-intermediate",
    newCourseSlug: "python-errors-data-formats",
    lessonSlug: "py2-ch6-quiz",
  },
  {
    oldKey: "python-intermediate/py2-class-basics",
    newKey: "python-classes-project/py2-class-basics",
    oldCourseSlug: "python-intermediate",
    newCourseSlug: "python-classes-project",
    lessonSlug: "py2-class-basics",
  },
  {
    oldKey: "python-intermediate/py2-init",
    newKey: "python-classes-project/py2-init",
    oldCourseSlug: "python-intermediate",
    newCourseSlug: "python-classes-project",
    lessonSlug: "py2-init",
  },
  {
    oldKey: "python-intermediate/py2-methods",
    newKey: "python-classes-project/py2-methods",
    oldCourseSlug: "python-intermediate",
    newCourseSlug: "python-classes-project",
    lessonSlug: "py2-methods",
  },
  {
    oldKey: "python-intermediate/py2-str-repr",
    newKey: "python-classes-project/py2-str-repr",
    oldCourseSlug: "python-intermediate",
    newCourseSlug: "python-classes-project",
    lessonSlug: "py2-str-repr",
  },
  {
    oldKey: "python-intermediate/py2-class-variables",
    newKey: "python-classes-project/py2-class-variables",
    oldCourseSlug: "python-intermediate",
    newCourseSlug: "python-classes-project",
    lessonSlug: "py2-class-variables",
  },
  {
    oldKey: "python-intermediate/py2-dataclass",
    newKey: "python-classes-project/py2-dataclass",
    oldCourseSlug: "python-intermediate",
    newCourseSlug: "python-classes-project",
    lessonSlug: "py2-dataclass",
  },
  {
    oldKey: "python-intermediate/py2-objects-comprehension",
    newKey: "python-classes-project/py2-objects-comprehension",
    oldCourseSlug: "python-intermediate",
    newCourseSlug: "python-classes-project",
    lessonSlug: "py2-objects-comprehension",
  },
  {
    oldKey: "python-intermediate/py2-ch7-build",
    newKey: "python-classes-project/py2-ch7-build",
    oldCourseSlug: "python-intermediate",
    newCourseSlug: "python-classes-project",
    lessonSlug: "py2-ch7-build",
  },
  {
    oldKey: "python-intermediate/py2-ch7-quiz",
    newKey: "python-classes-project/py2-ch7-quiz",
    oldCourseSlug: "python-intermediate",
    newCourseSlug: "python-classes-project",
    lessonSlug: "py2-ch7-quiz",
  },
  {
    oldKey: "python-intermediate/py2-final-structure",
    newKey: "python-classes-project/py2-final-structure",
    oldCourseSlug: "python-intermediate",
    newCourseSlug: "python-classes-project",
    lessonSlug: "py2-final-structure",
  },
  {
    oldKey: "python-intermediate/py2-final-report",
    newKey: "python-classes-project/py2-final-report",
    oldCourseSlug: "python-intermediate",
    newCourseSlug: "python-classes-project",
    lessonSlug: "py2-final-report",
  },
  {
    oldKey: "python-intermediate/py2-final-check",
    newKey: "python-classes-project/py2-final-check",
    oldCourseSlug: "python-intermediate",
    newCourseSlug: "python-classes-project",
    lessonSlug: "py2-final-check",
  },
  {
    oldKey: "python-intermediate/py2-final-extend",
    newKey: "python-classes-project/py2-final-extend",
    oldCourseSlug: "python-intermediate",
    newCourseSlug: "python-classes-project",
    lessonSlug: "py2-final-extend",
  },
  {
    oldKey: "python-intermediate/py2-final-next",
    newKey: "python-classes-project/py2-final-next",
    oldCourseSlug: "python-intermediate",
    newCourseSlug: "python-classes-project",
    lessonSlug: "py2-final-next",
  },
  {
    oldKey: "claude-code/cc-requirements",
    newKey: "claude-code-prompt-review/cc-requirements",
    oldCourseSlug: "claude-code",
    newCourseSlug: "claude-code-prompt-review",
    lessonSlug: "cc-requirements",
  },
  {
    oldKey: "claude-code/cc-acceptance-criteria",
    newKey: "claude-code-prompt-review/cc-acceptance-criteria",
    oldCourseSlug: "claude-code",
    newCourseSlug: "claude-code-prompt-review",
    lessonSlug: "cc-acceptance-criteria",
  },
  {
    oldKey: "claude-code/cc-split-tasks",
    newKey: "claude-code-prompt-review/cc-split-tasks",
    oldCourseSlug: "claude-code",
    newCourseSlug: "claude-code-prompt-review",
    lessonSlug: "cc-split-tasks",
  },
  {
    oldKey: "claude-code/cc-plan-first",
    newKey: "claude-code-prompt-review/cc-plan-first",
    oldCourseSlug: "claude-code",
    newCourseSlug: "claude-code-prompt-review",
    lessonSlug: "cc-plan-first",
  },
  {
    oldKey: "claude-code/cc-claude-md",
    newKey: "claude-code-prompt-review/cc-claude-md",
    oldCourseSlug: "claude-code",
    newCourseSlug: "claude-code-prompt-review",
    lessonSlug: "cc-claude-md",
  },
  {
    oldKey: "claude-code/cc-ch3-build",
    newKey: "claude-code-prompt-review/cc-ch3-build",
    oldCourseSlug: "claude-code",
    newCourseSlug: "claude-code-prompt-review",
    lessonSlug: "cc-ch3-build",
  },
  {
    oldKey: "claude-code/cc-ch3-quiz",
    newKey: "claude-code-prompt-review/cc-ch3-quiz",
    oldCourseSlug: "claude-code",
    newCourseSlug: "claude-code-prompt-review",
    lessonSlug: "cc-ch3-quiz",
  },
  {
    oldKey: "claude-code/cc-read-generated",
    newKey: "claude-code-prompt-review/cc-read-generated",
    oldCourseSlug: "claude-code",
    newCourseSlug: "claude-code-prompt-review",
    lessonSlug: "cc-read-generated",
  },
  {
    oldKey: "claude-code/cc-test-it",
    newKey: "claude-code-prompt-review/cc-test-it",
    oldCourseSlug: "claude-code",
    newCourseSlug: "claude-code-prompt-review",
    lessonSlug: "cc-test-it",
  },
  {
    oldKey: "claude-code/cc-have-it-test",
    newKey: "claude-code-prompt-review/cc-have-it-test",
    oldCourseSlug: "claude-code",
    newCourseSlug: "claude-code-prompt-review",
    lessonSlug: "cc-have-it-test",
  },
  {
    oldKey: "claude-code/cc-permissions-danger",
    newKey: "claude-code-prompt-review/cc-permissions-danger",
    oldCourseSlug: "claude-code",
    newCourseSlug: "claude-code-prompt-review",
    lessonSlug: "cc-permissions-danger",
  },
  {
    oldKey: "claude-code/cc-fix-loop",
    newKey: "claude-code-prompt-review/cc-fix-loop",
    oldCourseSlug: "claude-code",
    newCourseSlug: "claude-code-prompt-review",
    lessonSlug: "cc-fix-loop",
  },
  {
    oldKey: "claude-code/cc-ch4-build",
    newKey: "claude-code-prompt-review/cc-ch4-build",
    oldCourseSlug: "claude-code",
    newCourseSlug: "claude-code-prompt-review",
    lessonSlug: "cc-ch4-build",
  },
  {
    oldKey: "claude-code/cc-ch4-quiz",
    newKey: "claude-code-prompt-review/cc-ch4-quiz",
    oldCourseSlug: "claude-code",
    newCourseSlug: "claude-code-prompt-review",
    lessonSlug: "cc-ch4-quiz",
  },
  {
    oldKey: "claude-code/cc-fix-bug",
    newKey: "claude-code-workflow/cc-fix-bug",
    oldCourseSlug: "claude-code",
    newCourseSlug: "claude-code-workflow",
    lessonSlug: "cc-fix-bug",
  },
  {
    oldKey: "claude-code/cc-add-feature",
    newKey: "claude-code-workflow/cc-add-feature",
    oldCourseSlug: "claude-code",
    newCourseSlug: "claude-code-workflow",
    lessonSlug: "cc-add-feature",
  },
  {
    oldKey: "claude-code/cc-refactor",
    newKey: "claude-code-workflow/cc-refactor",
    oldCourseSlug: "claude-code",
    newCourseSlug: "claude-code-workflow",
    lessonSlug: "cc-refactor",
  },
  {
    oldKey: "claude-code/cc-docs-gen",
    newKey: "claude-code-workflow/cc-docs-gen",
    oldCourseSlug: "claude-code",
    newCourseSlug: "claude-code-workflow",
    lessonSlug: "cc-docs-gen",
  },
  {
    oldKey: "claude-code/cc-explore-codebase",
    newKey: "claude-code-workflow/cc-explore-codebase",
    oldCourseSlug: "claude-code",
    newCourseSlug: "claude-code-workflow",
    lessonSlug: "cc-explore-codebase",
  },
  {
    oldKey: "claude-code/cc-ch5-build",
    newKey: "claude-code-workflow/cc-ch5-build",
    oldCourseSlug: "claude-code",
    newCourseSlug: "claude-code-workflow",
    lessonSlug: "cc-ch5-build",
  },
  {
    oldKey: "claude-code/cc-ch5-quiz",
    newKey: "claude-code-workflow/cc-ch5-quiz",
    oldCourseSlug: "claude-code",
    newCourseSlug: "claude-code-workflow",
    lessonSlug: "cc-ch5-quiz",
  },
  {
    oldKey: "claude-code/cc-final-bigfeature",
    newKey: "claude-code-workflow/cc-final-bigfeature",
    oldCourseSlug: "claude-code",
    newCourseSlug: "claude-code-workflow",
    lessonSlug: "cc-final-bigfeature",
  },
  {
    oldKey: "claude-code/cc-final-review",
    newKey: "claude-code-workflow/cc-final-review",
    oldCourseSlug: "claude-code",
    newCourseSlug: "claude-code-workflow",
    lessonSlug: "cc-final-review",
  },
  {
    oldKey: "claude-code/cc-final-compare",
    newKey: "claude-code-workflow/cc-final-compare",
    oldCourseSlug: "claude-code",
    newCourseSlug: "claude-code-workflow",
    lessonSlug: "cc-final-compare",
  },
  {
    oldKey: "claude-code/cc-final-extend",
    newKey: "claude-code-workflow/cc-final-extend",
    oldCourseSlug: "claude-code",
    newCourseSlug: "claude-code-workflow",
    lessonSlug: "cc-final-extend",
  },
  {
    oldKey: "claude-code/cc-final-next",
    newKey: "claude-code-workflow/cc-final-next",
    oldCourseSlug: "claude-code",
    newCourseSlug: "claude-code-workflow",
    lessonSlug: "cc-final-next",
  },
  {
    oldKey: "it-passport/ipa-network-basics",
    newKey: "it-passport-network-database/ipa-network-basics",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-network-database",
    lessonSlug: "ipa-network-basics",
  },
  {
    oldKey: "it-passport/ipa-protocols",
    newKey: "it-passport-network-database/ipa-protocols",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-network-database",
    lessonSlug: "ipa-protocols",
  },
  {
    oldKey: "it-passport/ipa-web-email",
    newKey: "it-passport-network-database/ipa-web-email",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-network-database",
    lessonSlug: "ipa-web-email",
  },
  {
    oldKey: "it-passport/ipa-ip-address",
    newKey: "it-passport-network-database/ipa-ip-address",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-network-database",
    lessonSlug: "ipa-ip-address",
  },
  {
    oldKey: "it-passport/ipa-wireless",
    newKey: "it-passport-network-database/ipa-wireless",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-network-database",
    lessonSlug: "ipa-wireless",
  },
  {
    oldKey: "it-passport/ipa-ch4-kakomon",
    newKey: "it-passport-network-database/ipa-ch4-kakomon",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-network-database",
    lessonSlug: "ipa-ch4-kakomon",
  },
  {
    oldKey: "it-passport/ipa-db-basics",
    newKey: "it-passport-network-database/ipa-db-basics",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-network-database",
    lessonSlug: "ipa-db-basics",
  },
  {
    oldKey: "it-passport/ipa-relational",
    newKey: "it-passport-network-database/ipa-relational",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-network-database",
    lessonSlug: "ipa-relational",
  },
  {
    oldKey: "it-passport/ipa-sql-reading",
    newKey: "it-passport-network-database/ipa-sql-reading",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-network-database",
    lessonSlug: "ipa-sql-reading",
  },
  {
    oldKey: "it-passport/ipa-transaction",
    newKey: "it-passport-network-database/ipa-transaction",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-network-database",
    lessonSlug: "ipa-transaction",
  },
  {
    oldKey: "it-passport/ipa-backup",
    newKey: "it-passport-network-database/ipa-backup",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-network-database",
    lessonSlug: "ipa-backup",
  },
  {
    oldKey: "it-passport/ipa-ch5-kakomon",
    newKey: "it-passport-network-database/ipa-ch5-kakomon",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-network-database",
    lessonSlug: "ipa-ch5-kakomon",
  },
  {
    oldKey: "it-passport/ipa-threats",
    newKey: "it-passport-security-ai/ipa-threats",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-security-ai",
    lessonSlug: "ipa-threats",
  },
  {
    oldKey: "it-passport/ipa-malware-phishing",
    newKey: "it-passport-security-ai/ipa-malware-phishing",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-security-ai",
    lessonSlug: "ipa-malware-phishing",
  },
  {
    oldKey: "it-passport/ipa-auth-basics",
    newKey: "it-passport-security-ai/ipa-auth-basics",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-security-ai",
    lessonSlug: "ipa-auth-basics",
  },
  {
    oldKey: "it-passport/ipa-encryption",
    newKey: "it-passport-security-ai/ipa-encryption",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-security-ai",
    lessonSlug: "ipa-encryption",
  },
  {
    oldKey: "it-passport/ipa-security-management",
    newKey: "it-passport-security-ai/ipa-security-management",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-security-ai",
    lessonSlug: "ipa-security-management",
  },
  {
    oldKey: "it-passport/ipa-laws-security",
    newKey: "it-passport-security-ai/ipa-laws-security",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-security-ai",
    lessonSlug: "ipa-laws-security",
  },
  {
    oldKey: "it-passport/ipa-personal-info",
    newKey: "it-passport-security-ai/ipa-personal-info",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-security-ai",
    lessonSlug: "ipa-personal-info",
  },
  {
    oldKey: "it-passport/ipa-ch6-kakomon",
    newKey: "it-passport-security-ai/ipa-ch6-kakomon",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-security-ai",
    lessonSlug: "ipa-ch6-kakomon",
  },
  {
    oldKey: "it-passport/ipa-ai-basics",
    newKey: "it-passport-security-ai/ipa-ai-basics",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-security-ai",
    lessonSlug: "ipa-ai-basics",
  },
  {
    oldKey: "it-passport/ipa-generative-ai",
    newKey: "it-passport-security-ai/ipa-generative-ai",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-security-ai",
    lessonSlug: "ipa-generative-ai",
  },
  {
    oldKey: "it-passport/ipa-iot-bigdata",
    newKey: "it-passport-security-ai/ipa-iot-bigdata",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-security-ai",
    lessonSlug: "ipa-iot-bigdata",
  },
  {
    oldKey: "it-passport/ipa-emerging",
    newKey: "it-passport-security-ai/ipa-emerging",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-security-ai",
    lessonSlug: "ipa-emerging",
  },
  {
    oldKey: "it-passport/ipa-ai-ethics",
    newKey: "it-passport-security-ai/ipa-ai-ethics",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-security-ai",
    lessonSlug: "ipa-ai-ethics",
  },
  {
    oldKey: "it-passport/ipa-ch7-kakomon",
    newKey: "it-passport-security-ai/ipa-ch7-kakomon",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-security-ai",
    lessonSlug: "ipa-ch7-kakomon",
  },
  {
    oldKey: "it-passport/ipa-company-org",
    newKey: "it-passport-strategy/ipa-company-org",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-strategy",
    lessonSlug: "ipa-company-org",
  },
  {
    oldKey: "it-passport/ipa-accounting",
    newKey: "it-passport-strategy/ipa-accounting",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-strategy",
    lessonSlug: "ipa-accounting",
  },
  {
    oldKey: "it-passport/ipa-ip-law",
    newKey: "it-passport-strategy/ipa-ip-law",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-strategy",
    lessonSlug: "ipa-ip-law",
  },
  {
    oldKey: "it-passport/ipa-labor-contract",
    newKey: "it-passport-strategy/ipa-labor-contract",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-strategy",
    lessonSlug: "ipa-labor-contract",
  },
  {
    oldKey: "it-passport/ipa-compliance",
    newKey: "it-passport-strategy/ipa-compliance",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-strategy",
    lessonSlug: "ipa-compliance",
  },
  {
    oldKey: "it-passport/ipa-standardization",
    newKey: "it-passport-strategy/ipa-standardization",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-strategy",
    lessonSlug: "ipa-standardization",
  },
  {
    oldKey: "it-passport/ipa-ch8-kakomon",
    newKey: "it-passport-strategy/ipa-ch8-kakomon",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-strategy",
    lessonSlug: "ipa-ch8-kakomon",
  },
  {
    oldKey: "it-passport/ipa-strategy-basics",
    newKey: "it-passport-strategy/ipa-strategy-basics",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-strategy",
    lessonSlug: "ipa-strategy-basics",
  },
  {
    oldKey: "it-passport/ipa-marketing",
    newKey: "it-passport-strategy/ipa-marketing",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-strategy",
    lessonSlug: "ipa-marketing",
  },
  {
    oldKey: "it-passport/ipa-tech-strategy",
    newKey: "it-passport-strategy/ipa-tech-strategy",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-strategy",
    lessonSlug: "ipa-tech-strategy",
  },
  {
    oldKey: "it-passport/ipa-business-industry",
    newKey: "it-passport-strategy/ipa-business-industry",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-strategy",
    lessonSlug: "ipa-business-industry",
  },
  {
    oldKey: "it-passport/ipa-system-strategy",
    newKey: "it-passport-strategy/ipa-system-strategy",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-strategy",
    lessonSlug: "ipa-system-strategy",
  },
  {
    oldKey: "it-passport/ipa-system-planning",
    newKey: "it-passport-strategy/ipa-system-planning",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-strategy",
    lessonSlug: "ipa-system-planning",
  },
  {
    oldKey: "it-passport/ipa-dx",
    newKey: "it-passport-strategy/ipa-dx",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-strategy",
    lessonSlug: "ipa-dx",
  },
  {
    oldKey: "it-passport/ipa-ch9-kakomon",
    newKey: "it-passport-strategy/ipa-ch9-kakomon",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-strategy",
    lessonSlug: "ipa-ch9-kakomon",
  },
  {
    oldKey: "it-passport/ipa-dev-process",
    newKey: "it-passport-management-mock/ipa-dev-process",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-management-mock",
    lessonSlug: "ipa-dev-process",
  },
  {
    oldKey: "it-passport/ipa-agile",
    newKey: "it-passport-management-mock/ipa-agile",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-management-mock",
    lessonSlug: "ipa-agile",
  },
  {
    oldKey: "it-passport/ipa-estimation-test",
    newKey: "it-passport-management-mock/ipa-estimation-test",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-management-mock",
    lessonSlug: "ipa-estimation-test",
  },
  {
    oldKey: "it-passport/ipa-project-management",
    newKey: "it-passport-management-mock/ipa-project-management",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-management-mock",
    lessonSlug: "ipa-project-management",
  },
  {
    oldKey: "it-passport/ipa-service-management",
    newKey: "it-passport-management-mock/ipa-service-management",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-management-mock",
    lessonSlug: "ipa-service-management",
  },
  {
    oldKey: "it-passport/ipa-audit",
    newKey: "it-passport-management-mock/ipa-audit",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-management-mock",
    lessonSlug: "ipa-audit",
  },
  {
    oldKey: "it-passport/ipa-ch10-kakomon",
    newKey: "it-passport-management-mock/ipa-ch10-kakomon",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-management-mock",
    lessonSlug: "ipa-ch10-kakomon",
  },
  {
    oldKey: "it-passport/ipa-mock1",
    newKey: "it-passport-management-mock/ipa-mock1",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-management-mock",
    lessonSlug: "ipa-mock1",
  },
  {
    oldKey: "it-passport/ipa-mock2",
    newKey: "it-passport-management-mock/ipa-mock2",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-management-mock",
    lessonSlug: "ipa-mock2",
  },
  {
    oldKey: "it-passport/ipa-review-weak",
    newKey: "it-passport-management-mock/ipa-review-weak",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-management-mock",
    lessonSlug: "ipa-review-weak",
  },
  {
    oldKey: "it-passport/ipa-last-check",
    newKey: "it-passport-management-mock/ipa-last-check",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-management-mock",
    lessonSlug: "ipa-last-check",
  },
  {
    oldKey: "it-passport/ipa-final-next",
    newKey: "it-passport-management-mock/ipa-final-next",
    oldCourseSlug: "it-passport",
    newCourseSlug: "it-passport-management-mock",
    lessonSlug: "ipa-final-next",
  },
]) satisfies readonly CourseSplitV2StaticLessonAlias[];

export const COURSE_SPLIT_V2_OLD_TO_NEW_LESSON_KEY: Readonly<
  Record<string, string>
> = Object.freeze(
  Object.fromEntries(
    COURSE_SPLIT_V2_LESSON_ALIASES.map(({ oldKey, newKey }) => [
      oldKey,
      newKey,
    ]),
  ),
);

export const COURSE_SPLIT_V2_NEW_TO_OLD_LESSON_KEY: Readonly<
  Record<string, string>
> = Object.freeze(
  Object.fromEntries(
    COURSE_SPLIT_V2_LESSON_ALIASES.map(({ oldKey, newKey }) => [
      newKey,
      oldKey,
    ]),
  ),
);
